export const analyticsMockData = [
  {
    loadId: 28778355,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-03-07T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 325,
    miles: 30,
    margin: 151.13,
    rate: 476.13,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28766951,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-03-06T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 24916,
    carrierName: "Unlimited Carrier, Inc.",
    cost: 300,
    miles: 8,
    margin: 165,
    rate: 465,
    customerId: 216446,
    customerName: "DHL - US Domestic"
  },
  {
    loadId: 28758693,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2023-03-02T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28756164,
    originCityId: 6436,
    originCityName: "Elk Grove Village",
    originStateCode: "IL",
    originLatitude: 41.988,
    originLongitude: -87.976,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2023-03-02T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 38691,
    carrierName: "Acme Transportation Company",
    cost: 300,
    miles: 24,
    margin: 125,
    rate: 425,
    customerId: 223680,
    customerName: "Rdi Scrap Recycling Inc"
  },
  {
    loadId: 28679351,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6383,
    destinationCityName: "Des Plaines",
    destinationStateCode: "IL",
    destinationLatitude: 42.041,
    destinationLongitude: -87.888,
    loadDate: "2023-03-02T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 337204,
    carrierName: "Halo Express",
    cost: 300,
    miles: 10,
    margin: 29.5,
    rate: 329.5,
    customerId: 210537,
    customerName: "Richelieu Foods c/o Ryder - EDI"
  },
  {
    loadId: 28716251,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2023-03-01T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 199824,
    carrierName: "WJK Trans, Inc.",
    cost: 475,
    miles: 29,
    margin: 125,
    rate: 600,
    customerId: 180538,
    customerName: "Coast Beacon"
  },
  {
    loadId: 28723580,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2023-02-24T00:00:00",
    equipmentTypes: [18],
    rank: 203,
    carrierId: 424084,
    carrierName: "JHR TRANSPORTATION INC",
    cost: 350,
    miles: 30,
    margin: 25,
    rate: 375,
    customerId: 163895,
    customerName: "Xtra Lease LLC - Midway"
  },
  {
    loadId: 28714314,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-02-24T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 423470,
    carrierName: "ALWAYS ON THE RUN TRUCKING LLC",
    cost: 314,
    miles: 30,
    margin: 165.67,
    rate: 479.67,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28712700,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2023-02-23T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28667263,
    originCityId: 6503,
    originCityName: "Franklin Park",
    originStateCode: "IL",
    originLatitude: 41.949,
    originLongitude: -87.878,
    destinationCityId: 6344,
    destinationCityName: "Country Club Hills",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.739,
    loadDate: "2023-02-23T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 199721,
    carrierName: "MTZ Trucking Services, Inc.",
    cost: 300,
    miles: 36,
    margin: 36,
    rate: 336,
    customerId: 239922,
    customerName: "S. C. Johnson & Son, Inc. - Project"
  },
  {
    loadId: 28686362,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-02-22T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 423470,
    carrierName: "ALWAYS ON THE RUN TRUCKING LLC",
    cost: 330,
    miles: 30,
    margin: 149.67,
    rate: 479.67,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28679491,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2023-02-22T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 275181,
    carrierName: "Mon Pride Express, Inc.",
    cost: 450,
    miles: 0,
    margin: 125,
    rate: 575,
    customerId: 180538,
    customerName: "Coast Beacon"
  },
  {
    loadId: 28694097,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2023-02-21T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28693772,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2023-02-21T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 17,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28690455,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2023-02-21T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 330510,
    carrierName: "Zoko Freight, Inc.",
    cost: 300,
    miles: 10,
    margin: 185.3,
    rate: 485.3,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 28679959,
    originCityId: 29730,
    originCityName: "Northlake",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.904,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2023-02-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 300,
    miles: 16,
    margin: 100,
    rate: 400,
    customerId: 823,
    customerName: "Fattah Trading Company Inc"
  },
  {
    loadId: 28669365,
    originCityId: 6654,
    originCityName: "Itasca",
    originStateCode: "IL",
    originLatitude: 41.971,
    originLongitude: -88.018,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2023-02-17T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 276450,
    carrierName: "AKS Transport, Inc.",
    cost: 500,
    miles: 45,
    margin: 135.3,
    rate: 635.3,
    customerId: 67674,
    customerName: "The Valspar Corporation/Sherwin Williams"
  },
  {
    loadId: 28666663,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2023-02-16T00:00:00",
    equipmentTypes: [3],
    rank: 203,
    carrierId: 387609,
    carrierName: "GDT Trans, Inc.",
    cost: 500,
    miles: 7,
    margin: 37.5,
    rate: 537.5,
    customerId: 69847,
    customerName: "BWAY Corporation- USD"
  },
  {
    loadId: 28664292,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-02-16T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 122483,
    carrierName: "Bruges Transport and Logistics, LLC.",
    cost: 325,
    miles: 30,
    margin: 156.44,
    rate: 481.44,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28639890,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2023-02-16T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185.1,
    rate: 485.1,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 28588728,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6383,
    destinationCityName: "Des Plaines",
    destinationStateCode: "IL",
    destinationLatitude: 42.041,
    destinationLongitude: -87.888,
    loadDate: "2023-02-16T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 329247,
    carrierName: "Geneva Transport LLC",
    cost: 300,
    miles: 10,
    margin: 54.7,
    rate: 354.7,
    customerId: 210537,
    customerName: "Richelieu Foods c/o Ryder - EDI"
  },
  {
    loadId: 28663574,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2023-02-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28652046,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2023-02-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 17,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28637244,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-02-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 423470,
    carrierName: "ALWAYS ON THE RUN TRUCKING LLC",
    cost: 334,
    miles: 30,
    margin: 147.44,
    rate: 481.44,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28637213,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-02-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 334,
    miles: 30,
    margin: 147.44,
    rate: 481.44,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28631614,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 29730,
    destinationCityName: "Northlake",
    destinationStateCode: "IL",
    destinationLatitude: 41.91,
    destinationLongitude: -87.904,
    loadDate: "2023-02-13T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 282119,
    carrierName: "RWOY Trucking Inc",
    cost: 400,
    miles: 7,
    margin: 153.58,
    rate: 553.58,
    customerId: 7709,
    customerName: "Ferrara Candy Company"
  },
  {
    loadId: 28631613,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2023-02-13T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185.1,
    rate: 485.1,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 28614203,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6269,
    destinationCityName: "Carol Stream",
    destinationStateCode: "IL",
    destinationLatitude: 41.904,
    destinationLongitude: -88.121,
    loadDate: "2023-02-13T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 199721,
    carrierName: "MTZ Trucking Services, Inc.",
    cost: 300,
    miles: 0,
    margin: 175.95,
    rate: 475.95,
    customerId: 92671,
    customerName: "The Kraft Heinz Company - CL77"
  },
  {
    loadId: 28528492,
    originCityId: 6503,
    originCityName: "Franklin Park",
    originStateCode: "IL",
    originLatitude: 41.949,
    originLongitude: -87.878,
    destinationCityId: 1557398,
    destinationCityName: "Hodgkins",
    destinationStateCode: "IL",
    destinationLatitude: 41.818,
    destinationLongitude: -87.87,
    loadDate: "2023-02-12T00:00:00",
    equipmentTypes: [2],
    rank: 202,
    carrierId: 219503,
    carrierName: "AG Carriers, Inc.",
    cost: 850,
    miles: 13,
    margin: 367.41,
    rate: 1217.41,
    customerId: 186266,
    customerName: "UPSDS - FTD - Post-Petition DB"
  },
  {
    loadId: 28624752,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6503,
    destinationCityName: "Franklin Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.949,
    destinationLongitude: -87.878,
    loadDate: "2023-02-09T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 329247,
    carrierName: "Geneva Transport LLC",
    cost: 350,
    miles: 27,
    margin: 50,
    rate: 400,
    customerId: 204990,
    customerName: "The Urgent Company"
  },
  {
    loadId: 28569688,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6383,
    destinationCityName: "Des Plaines",
    destinationStateCode: "IL",
    destinationLatitude: 42.041,
    destinationLongitude: -87.888,
    loadDate: "2023-02-09T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 246919,
    carrierName: "Romco",
    cost: 300,
    miles: 10,
    margin: 4.8,
    rate: 304.8,
    customerId: 210537,
    customerName: "Richelieu Foods c/o Ryder - EDI"
  },
  {
    loadId: 28613569,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-02-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 337,
    miles: 30,
    margin: 147.98,
    rate: 484.98,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28613551,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-02-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 189887,
    carrierName: "Landliner, Inc.",
    cost: 325,
    miles: 30,
    margin: 159.98,
    rate: 484.98,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28605512,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 6928,
    destinationCityName: "Niles",
    destinationStateCode: "IL",
    destinationLatitude: 42.023,
    destinationLongitude: -87.81,
    loadDate: "2023-02-08T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 18,
    margin: 104.72,
    rate: 404.72,
    customerId: 82032,
    customerName: "Ingredion Incorporated / Corn Products Intl."
  },
  {
    loadId: 28602259,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6829,
    destinationCityName: "Melrose Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.91,
    destinationLongitude: -87.837,
    loadDate: "2023-02-07T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 270337,
    carrierName: "EUGENE TRANSPORT INC",
    cost: 273.4,
    miles: 12,
    margin: 101.6,
    rate: 375,
    customerId: 230589,
    customerName: "EB-Books, LLC"
  },
  {
    loadId: 28596763,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6249,
    destinationCityName: "Calumet City",
    destinationStateCode: "IL",
    destinationLatitude: 41.601,
    destinationLongitude: -87.559,
    loadDate: "2023-02-07T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 369480,
    carrierName: "AAE Trucking Services Inc",
    cost: 300,
    miles: 21,
    margin: 58.8,
    rate: 358.8,
    customerId: 82032,
    customerName: "Ingredion Incorporated / Corn Products Intl."
  },
  {
    loadId: 28586757,
    originCityId: 6731,
    originCityName: "Lemont",
    originStateCode: "IL",
    originLatitude: 41.644,
    originLongitude: -87.99,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2023-02-06T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 220293,
    carrierName: "Scorpion Express Logistics Corp",
    cost: 325,
    miles: 26,
    margin: 29,
    rate: 354,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 28569686,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6383,
    destinationCityName: "Des Plaines",
    destinationStateCode: "IL",
    destinationLatitude: 42.041,
    destinationLongitude: -87.888,
    loadDate: "2023-02-06T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 146840,
    carrierName: "Quick Freight Logistics, Inc.",
    cost: 300,
    miles: 10,
    margin: 4.8,
    rate: 304.8,
    customerId: 210537,
    customerName: "Richelieu Foods c/o Ryder - EDI"
  },
  {
    loadId: 28559236,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2023-02-06T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185.1,
    rate: 485.1,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 28589562,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 7350,
    destinationCityName: "Wood Dale",
    destinationStateCode: "IL",
    destinationLatitude: 41.962,
    destinationLongitude: -87.96,
    loadDate: "2023-02-03T00:00:00",
    equipmentTypes: [45],
    rank: 203,
    carrierId: 187851,
    carrierName: "Mainland Corp",
    cost: 420,
    miles: 20,
    margin: 95,
    rate: 515,
    customerId: 171963,
    customerName: "Heat Transfer Division of Primary Metals Int'l LLC"
  },
  {
    loadId: 28571833,
    originCityId: 6731,
    originCityName: "Lemont",
    originStateCode: "IL",
    originLatitude: 41.644,
    originLongitude: -87.99,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2023-02-03T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 496554,
    carrierName: "AARON FREIGHT LLC",
    cost: 350,
    miles: 26,
    margin: 4,
    rate: 354,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 28559229,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2023-02-03T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185.2,
    rate: 485.2,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 28584613,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2023-02-02T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 38,
    margin: 100,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28584260,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2023-02-02T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28559125,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2023-02-01T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185.2,
    rate: 485.2,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 28565744,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2023-01-31T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 17,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28560176,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-01-31T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 423470,
    carrierName: "ALWAYS ON THE RUN TRUCKING LLC",
    cost: 330,
    miles: 30,
    margin: 158.52,
    rate: 488.52,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28553742,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2023-01-31T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185.2,
    rate: 485.2,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 28553024,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2023-01-31T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185.2,
    rate: 485.2,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 28557393,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2023-01-30T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28549515,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2023-01-27T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 350,
    miles: 38,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28534724,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-01-26T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 331,
    miles: 30,
    margin: 157.52,
    rate: 488.52,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28515423,
    originCityId: 1557906,
    originCityName: "Argo",
    originStateCode: "IL",
    originLatitude: 41.781,
    originLongitude: -87.826,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2023-01-26T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 189887,
    carrierName: "Landliner, Inc.",
    cost: 300,
    miles: 12,
    margin: 80.72,
    rate: 380.72,
    customerId: 11590,
    customerName: "Batory Foods / Chicago Sweeteners"
  },
  {
    loadId: 28515588,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6928,
    destinationCityName: "Niles",
    destinationStateCode: "IL",
    destinationLatitude: 42.023,
    destinationLongitude: -87.81,
    loadDate: "2023-01-25T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 103,
    carrierName: "HMD Trucking, Inc.",
    cost: 275.64,
    miles: 32,
    margin: 54.8,
    rate: 330.44,
    customerId: 23969,
    customerName: "Multi-Color Corporation"
  },
  {
    loadId: 28520528,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2023-01-24T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 17,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28515589,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6928,
    destinationCityName: "Niles",
    destinationStateCode: "IL",
    destinationLatitude: 42.023,
    destinationLongitude: -87.81,
    loadDate: "2023-01-24T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 103,
    carrierName: "HMD Trucking, Inc.",
    cost: 275,
    miles: 32,
    margin: 55.44,
    rate: 330.44,
    customerId: 23969,
    customerName: "Multi-Color Corporation"
  },
  {
    loadId: 28496701,
    originCityId: 6731,
    originCityName: "Lemont",
    originStateCode: "IL",
    originLatitude: 41.644,
    originLongitude: -87.99,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2023-01-23T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 407650,
    carrierName: "EMR Cargo, LLC",
    cost: 280,
    miles: 24,
    margin: 77,
    rate: 357,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 28490567,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2023-01-23T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185.1,
    rate: 485.1,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 28500725,
    originCityId: 6539,
    originCityName: "Glendale Heights",
    originStateCode: "IL",
    originLatitude: 41.857,
    originLongitude: -88.048,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2023-01-20T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 28,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28490199,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2023-01-19T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28474173,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2023-01-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28362193,
    originCityId: 29730,
    originCityName: "Northlake",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.904,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-01-17T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 81230,
    carrierName: "G & K Transportation, Inc.",
    cost: 300,
    miles: 12,
    margin: 350,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 28464696,
    originCityId: 6928,
    originCityName: "Niles",
    originStateCode: "IL",
    originLatitude: 42.023,
    originLongitude: -87.81,
    destinationCityId: 6179,
    destinationCityName: "Berkeley",
    destinationStateCode: "IL",
    destinationLatitude: 41.903,
    destinationLongitude: -87.903,
    loadDate: "2023-01-16T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 146840,
    carrierName: "Quick Freight Logistics, Inc.",
    cost: 350,
    miles: 15,
    margin: 65.9,
    rate: 415.9,
    customerId: 23969,
    customerName: "Multi-Color Corporation"
  },
  {
    loadId: 28464452,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2023-01-16T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 100,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28460491,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 6176,
    destinationCityName: "Bensenville",
    destinationStateCode: "IL",
    destinationLatitude: 41.958,
    destinationLongitude: -87.918,
    loadDate: "2023-01-16T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 21466,
    carrierName: "Merx Global, Inc.",
    cost: 500,
    miles: 20,
    margin: 250,
    rate: 750,
    customerId: 39830,
    customerName: "TR International Trading Company"
  },
  {
    loadId: 28441938,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-01-13T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 270337,
    carrierName: "EUGENE TRANSPORT INC",
    cost: 400,
    miles: 8,
    margin: 250,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 28416989,
    originCityId: 29730,
    originCityName: "Northlake",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.904,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-01-13T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 212322,
    carrierName: "RRC TRUCKING INC",
    cost: 350,
    miles: 12,
    margin: 300,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 28450043,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2023-01-12T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 189887,
    carrierName: "Landliner, Inc.",
    cost: 300,
    miles: 17,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28443336,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 7355,
    destinationCityName: "Woodridge",
    destinationStateCode: "IL",
    destinationLatitude: 41.738,
    destinationLongitude: -88.028,
    loadDate: "2023-01-12T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 189899,
    carrierName: "State Express Inc",
    cost: 275,
    miles: 21,
    margin: 275,
    rate: 550,
    customerId: 81064,
    customerName: "Personal Creations"
  },
  {
    loadId: 28432381,
    originCityId: 6539,
    originCityName: "Glendale Heights",
    originStateCode: "IL",
    originLatitude: 41.857,
    originLongitude: -88.048,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2023-01-11T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 189887,
    carrierName: "Landliner, Inc.",
    cost: 325,
    miles: 21,
    margin: 100,
    rate: 425,
    customerId: 148592,
    customerName: "UPS - New Hub Conveyor Project"
  },
  {
    loadId: 28424960,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2023-01-10T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 189887,
    carrierName: "Landliner, Inc.",
    cost: 400,
    miles: 30,
    margin: 84.98,
    rate: 484.98,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28416182,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 7350,
    destinationCityName: "Wood Dale",
    destinationStateCode: "IL",
    destinationLatitude: 41.962,
    destinationLongitude: -87.96,
    loadDate: "2023-01-09T00:00:00",
    equipmentTypes: [45],
    rank: 203,
    carrierId: 47068,
    carrierName: "Top Freight Express Incorporated",
    cost: 350,
    miles: 20,
    margin: 165,
    rate: 515,
    customerId: 171963,
    customerName: "Heat Transfer Division of Primary Metals Int'l LLC"
  },
  {
    loadId: 28414505,
    originCityId: 7165,
    originCityName: "Skokie",
    originStateCode: "IL",
    originLatitude: 42.04,
    originLongitude: -87.748,
    destinationCityId: 7327,
    destinationCityName: "Wheeling",
    destinationStateCode: "IL",
    destinationLatitude: 42.139,
    destinationLongitude: -87.91,
    loadDate: "2023-01-09T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 189667,
    carrierName: "Luka Transportation, Inc.",
    cost: 325,
    miles: 12,
    margin: 650,
    rate: 975,
    customerId: 220805,
    customerName: "Yours Beverage, LLC"
  },
  {
    loadId: 28384884,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2023-01-06T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 186,
    rate: 486,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 28293111,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2023-01-06T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 189489,
    carrierName: "AG Expedited Inc",
    cost: 400,
    miles: 29,
    margin: -60,
    rate: 340,
    customerId: 68849,
    customerName: "Blommer Chocolate (IL)"
  },
  {
    loadId: 28293110,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2023-01-06T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 189887,
    carrierName: "Landliner, Inc.",
    cost: 300,
    miles: 29,
    margin: 40,
    rate: 340,
    customerId: 68849,
    customerName: "Blommer Chocolate (IL)"
  },
  {
    loadId: 28402322,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2023-01-05T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 100,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28402221,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2023-01-05T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 17,
    margin: 100,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28367704,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2023-01-05T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 189887,
    carrierName: "Landliner, Inc.",
    cost: 300,
    miles: 29,
    margin: 40,
    rate: 340,
    customerId: 68849,
    customerName: "Blommer Chocolate (IL)"
  },
  {
    loadId: 28367695,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2023-01-05T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 329247,
    carrierName: "Geneva Transport LLC",
    cost: 325,
    miles: 29,
    margin: 15,
    rate: 340,
    customerId: 68849,
    customerName: "Blommer Chocolate (IL)"
  },
  {
    loadId: 28385775,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2023-01-04T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 400,
    miles: 38,
    margin: 50,
    rate: 450,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28383564,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2023-01-03T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 17,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28366252,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 7355,
    destinationCityName: "Woodridge",
    destinationStateCode: "IL",
    destinationLatitude: 41.738,
    destinationLongitude: -88.028,
    loadDate: "2022-12-30T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 400,
    miles: 4,
    margin: 200,
    rate: 600,
    customerId: 35655,
    customerName: "Guayaki Sustainable Rainforest Products, Inc."
  },
  {
    loadId: 28364219,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 7355,
    destinationCityName: "Woodridge",
    destinationStateCode: "IL",
    destinationLatitude: 41.738,
    destinationLongitude: -88.028,
    loadDate: "2022-12-29T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 400,
    miles: 4,
    margin: 200,
    rate: 600,
    customerId: 35655,
    customerName: "Guayaki Sustainable Rainforest Products, Inc."
  },
  {
    loadId: 28364214,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 7355,
    destinationCityName: "Woodridge",
    destinationStateCode: "IL",
    destinationLatitude: 41.738,
    destinationLongitude: -88.028,
    loadDate: "2022-12-29T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 400,
    miles: 4,
    margin: 200,
    rate: 600,
    customerId: 35655,
    customerName: "Guayaki Sustainable Rainforest Products, Inc."
  },
  {
    loadId: 28322169,
    originCityId: 7350,
    originCityName: "Wood Dale",
    originStateCode: "IL",
    originLatitude: 41.962,
    originLongitude: -87.96,
    destinationCityId: 6829,
    destinationCityName: "Melrose Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.91,
    destinationLongitude: -87.837,
    loadDate: "2022-12-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 389876,
    carrierName: "St 2 St Inc",
    cost: 400,
    miles: 10,
    margin: -50,
    rate: 350,
    customerId: 53749,
    customerName: "D&W Fine Pack LLC"
  },
  {
    loadId: 28321115,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-12-29T00:00:00",
    equipmentTypes: [2],
    rank: 202,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 550,
    miles: 0.4,
    margin: 152.03,
    rate: 702.03,
    customerId: 65914,
    customerName: "LXP Armada"
  },
  {
    loadId: 28335514,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-12-27T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 29,
    margin: 250,
    rate: 550,
    customerId: 53135,
    customerName: "Global CPG, LLC"
  },
  {
    loadId: 28272554,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-12-27T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 2794,
    carrierName: "Altex Transportation, Inc.",
    cost: 350,
    miles: 0,
    margin: 230.96,
    rate: 580.96,
    customerId: 61312,
    customerName: "Woodbolt International"
  },
  {
    loadId: 28319044,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-12-22T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 498572,
    carrierName: "CARGO EXP INC",
    cost: 400,
    miles: 29,
    margin: -60,
    rate: 340,
    customerId: 68849,
    customerName: "Blommer Chocolate (IL)"
  },
  {
    loadId: 28314862,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-12-22T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 270337,
    carrierName: "EUGENE TRANSPORT INC",
    cost: 300,
    miles: 8,
    margin: 350,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 28321475,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-12-21T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 350,
    miles: 8,
    margin: 115,
    rate: 465,
    customerId: 216446,
    customerName: "DHL - US Domestic"
  },
  {
    loadId: 28304803,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-12-19T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 100,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28298956,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6829,
    destinationCityName: "Melrose Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.91,
    destinationLongitude: -87.837,
    loadDate: "2022-12-19T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 325,
    miles: 14,
    margin: 64,
    rate: 389,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 28290068,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 6176,
    destinationCityName: "Bensenville",
    destinationStateCode: "IL",
    destinationLatitude: 41.958,
    destinationLongitude: -87.918,
    loadDate: "2022-12-19T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 21466,
    carrierName: "Merx Global, Inc.",
    cost: 500,
    miles: 20,
    margin: 125,
    rate: 625,
    customerId: 39830,
    customerName: "TR International Trading Company"
  },
  {
    loadId: 28292998,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-12-16T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 253693,
    carrierName: "Dignity Logistics Inc",
    cost: 275,
    miles: 29,
    margin: 65,
    rate: 340,
    customerId: 68849,
    customerName: "Blommer Chocolate (IL)"
  },
  {
    loadId: 28292743,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-12-16T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 440142,
    carrierName: "REYES EXPRESS INC",
    cost: 350,
    miles: 29,
    margin: -10,
    rate: 340,
    customerId: 68849,
    customerName: "Blommer Chocolate (IL)"
  },
  {
    loadId: 28292253,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-12-16T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 32468,
    carrierName: "Get Cargo, Inc.",
    cost: 400,
    miles: 30,
    margin: 101.79,
    rate: 501.79,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28285192,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-12-16T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 406740,
    carrierName: "Ahead Of Time Transport Inc",
    cost: 300,
    miles: 8,
    margin: 100,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28251755,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-12-16T00:00:00",
    equipmentTypes: [2],
    rank: 202,
    carrierId: 405564,
    carrierName: "BNJ Trucking Inc",
    cost: 600,
    miles: 0.4,
    margin: 102.03,
    rate: 702.03,
    customerId: 65914,
    customerName: "LXP Armada"
  },
  {
    loadId: 28279524,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6885,
    destinationCityName: "Mount Prospect",
    destinationStateCode: "IL",
    destinationLatitude: 42.064,
    destinationLongitude: -87.937,
    loadDate: "2022-12-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 358612,
    carrierName: "Dutch Express Inc",
    cost: 400,
    miles: 42,
    margin: 50,
    rate: 450,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28272921,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-12-14T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 450,
    miles: 30,
    margin: 51.79,
    rate: 501.79,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28255588,
    originCityId: 7174,
    originCityName: "South Holland",
    originStateCode: "IL",
    originLatitude: 41.6,
    originLongitude: -87.584,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-12-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 343250,
    carrierName: "Sjt Trucking Inc",
    cost: 315,
    miles: 20,
    margin: 34,
    rate: 349,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 28264871,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-12-13T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 189887,
    carrierName: "Landliner, Inc.",
    cost: 350,
    miles: 38,
    margin: 100,
    rate: 450,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28254484,
    originCityId: 7096,
    originCityName: "Roselle",
    originStateCode: "IL",
    originLatitude: 41.977,
    originLongitude: -88.076,
    destinationCityId: 29730,
    destinationCityName: "Northlake",
    destinationStateCode: "IL",
    destinationLatitude: 41.91,
    destinationLongitude: -87.904,
    loadDate: "2022-12-13T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 374895,
    carrierName: "KOBRA MOBILE INC",
    cost: 325,
    miles: 13,
    margin: 181.26,
    rate: 506.26,
    customerId: 60642,
    customerName: "Pregis LLC"
  },
  {
    loadId: 28240267,
    originCityId: 6539,
    originCityName: "Glendale Heights",
    originStateCode: "IL",
    originLatitude: 41.857,
    originLongitude: -88.048,
    destinationCityId: 7165,
    destinationCityName: "Skokie",
    destinationStateCode: "IL",
    destinationLatitude: 42.04,
    destinationLongitude: -87.748,
    loadDate: "2022-12-12T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 406740,
    carrierName: "Ahead Of Time Transport Inc",
    cost: 330,
    miles: 32,
    margin: 70,
    rate: 400,
    customerId: 148592,
    customerName: "UPS - New Hub Conveyor Project"
  },
  {
    loadId: 28236373,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-12-12T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 30572,
    carrierName: "A&M Quality Transport, Inc.",
    cost: 285,
    miles: 4,
    margin: 49,
    rate: 334,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 28247270,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-12-09T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 100,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28237908,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-12-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 205839,
    carrierName: "VHS Trucking, Inc.",
    cost: 300,
    miles: 8,
    margin: 50,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28235802,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-12-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 38,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28233442,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-12-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 100,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28227937,
    originCityId: 6539,
    originCityName: "Glendale Heights",
    originStateCode: "IL",
    originLatitude: 41.857,
    originLongitude: -88.048,
    destinationCityId: 7165,
    destinationCityName: "Skokie",
    destinationStateCode: "IL",
    destinationLatitude: 42.04,
    destinationLongitude: -87.748,
    loadDate: "2022-12-08T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 32,
    margin: 100,
    rate: 400,
    customerId: 148592,
    customerName: "UPS - New Hub Conveyor Project"
  },
  {
    loadId: 28210857,
    originCityId: 7350,
    originCityName: "Wood Dale",
    originStateCode: "IL",
    originLatitude: 41.962,
    originLongitude: -87.96,
    destinationCityId: 6829,
    destinationCityName: "Melrose Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.91,
    destinationLongitude: -87.837,
    loadDate: "2022-12-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 146840,
    carrierName: "Quick Freight Logistics, Inc.",
    cost: 300,
    miles: 10,
    margin: 25,
    rate: 325,
    customerId: 53749,
    customerName: "D&W Fine Pack LLC"
  },
  {
    loadId: 28223042,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 6213,
    destinationCityName: "Bridgeview",
    destinationStateCode: "IL",
    destinationLatitude: 41.75,
    destinationLongitude: -87.804,
    loadDate: "2022-12-07T00:00:00",
    equipmentTypes: [3],
    rank: 203,
    carrierId: 34662,
    carrierName: "Hot Rod Trucking Services, Inc.",
    cost: 450,
    miles: 1,
    margin: -50,
    rate: 400,
    customerId: 13444,
    customerName: "Signode Industrial Group LLC"
  },
  {
    loadId: 28218966,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-12-07T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 455357,
    carrierName: "ALL IN LOGISTICS LLC",
    cost: 300,
    miles: 29,
    margin: 40,
    rate: 340,
    customerId: 68849,
    customerName: "Blommer Chocolate (IL)"
  },
  {
    loadId: 28218948,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-12-07T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 444851,
    carrierName: "SHAKRO TRUCKING INC",
    cost: 300,
    miles: 29,
    margin: 40,
    rate: 340,
    customerId: 68849,
    customerName: "Blommer Chocolate (IL)"
  },
  {
    loadId: 28200346,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-12-05T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 480659,
    carrierName: "TIDATLOGISTICS LLC",
    cost: 300,
    miles: 29,
    margin: 40,
    rate: 340,
    customerId: 68849,
    customerName: "Blommer Chocolate (IL)"
  },
  {
    loadId: 28154768,
    originCityId: 29730,
    originCityName: "Northlake",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.904,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-12-05T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 406740,
    carrierName: "Ahead Of Time Transport Inc",
    cost: 300,
    miles: 12,
    margin: 350,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 28183137,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-12-02T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 100,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28172755,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-12-02T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 189899,
    carrierName: "State Express Inc",
    cost: 300,
    miles: 30,
    margin: 35,
    rate: 335,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 28123601,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-12-02T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 350,
    miles: 4,
    margin: -26,
    rate: 324,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 28179423,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-12-01T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 100,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28177771,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-12-01T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 489830,
    carrierName: "Flores Fast Movers Inc",
    cost: 300,
    miles: 29,
    margin: 40,
    rate: 340,
    customerId: 68849,
    customerName: "Blommer Chocolate (IL)"
  },
  {
    loadId: 28170021,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-12-01T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 200,
    rate: 500,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28146999,
    originCityId: 29730,
    originCityName: "Northlake",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.904,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-12-01T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 406740,
    carrierName: "Ahead Of Time Transport Inc",
    cost: 300,
    miles: 12,
    margin: 350,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 28154000,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-11-30T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 186.7,
    rate: 486.7,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 28154339,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-11-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 489631,
    carrierName: "GALACTICA TRANSPORTATION LLC",
    cost: 300,
    miles: 29,
    margin: 40,
    rate: 340,
    customerId: 68849,
    customerName: "Blommer Chocolate (IL)"
  },
  {
    loadId: 28089536,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-11-29T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 186.7,
    rate: 486.7,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 28079704,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-11-29T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 387361,
    carrierName: "Royalty Truck Lines Inc",
    cost: 500,
    miles: 29,
    margin: 150,
    rate: 650,
    customerId: 180538,
    customerName: "Coast Beacon"
  },
  {
    loadId: 28079681,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-11-29T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 387361,
    carrierName: "Royalty Truck Lines Inc",
    cost: 500,
    miles: 29,
    margin: 150,
    rate: 650,
    customerId: 180538,
    customerName: "Coast Beacon"
  },
  {
    loadId: 28114727,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-11-28T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 29,
    margin: 225,
    rate: 525,
    customerId: 53135,
    customerName: "Global CPG, LLC"
  },
  {
    loadId: 28113620,
    originCityId: 6398,
    originCityName: "Downers Grove",
    originStateCode: "IL",
    originLatitude: 41.809,
    originLongitude: -88.011,
    destinationCityId: 6744,
    destinationCityName: "Lincolnwood",
    destinationStateCode: "IL",
    destinationLatitude: 42.008,
    destinationLongitude: -87.702,
    loadDate: "2022-11-28T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 31,
    margin: 150,
    rate: 450,
    customerId: 53769,
    customerName: "Axiz Group, L.L.C."
  },
  {
    loadId: 28114624,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6885,
    destinationCityName: "Mount Prospect",
    destinationStateCode: "IL",
    destinationLatitude: 42.064,
    destinationLongitude: -87.937,
    loadDate: "2022-11-23T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 375,
    miles: 42,
    margin: 125,
    rate: 500,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28113335,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-11-23T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 100,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28079161,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-11-23T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 315,
    miles: 8,
    margin: 335,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 28078822,
    originCityId: 6087,
    originCityName: "Addison",
    originStateCode: "IL",
    originLatitude: 41.939,
    originLongitude: -88.033,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2022-11-22T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 411243,
    carrierName: "Lit Group Inc",
    cost: 334.84,
    miles: 24,
    margin: 110.16,
    rate: 445,
    customerId: 2642,
    customerName: "The Chamberlain Group Inc"
  },
  {
    loadId: 28075914,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-11-18T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 171279,
    carrierName: "Alynevych, Inc.",
    cost: 500,
    miles: 15,
    margin: 180,
    rate: 680,
    customerId: 37715,
    customerName: "American Sugar Refining"
  },
  {
    loadId: 28066492,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-11-18T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 400,
    miles: 30,
    margin: 105.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28066426,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-11-18T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 360,
    miles: 30,
    margin: 145.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28066395,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-11-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 38,
    margin: 100,
    rate: 450,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 28052182,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-11-17T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 80236,
    carrierName: "Arsa Transportation, Inc.",
    cost: 500,
    miles: 0,
    margin: 100,
    rate: 600,
    customerId: 180538,
    customerName: "Coast Beacon"
  },
  {
    loadId: 28021467,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-11-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 400,
    miles: 30,
    margin: 105.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 28020039,
    originCityId: 7096,
    originCityName: "Roselle",
    originStateCode: "IL",
    originLatitude: 41.977,
    originLongitude: -88.076,
    destinationCityId: 6269,
    destinationCityName: "Carol Stream",
    destinationStateCode: "IL",
    destinationLatitude: 41.904,
    destinationLongitude: -88.121,
    loadDate: "2022-11-15T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 406740,
    carrierName: "Ahead Of Time Transport Inc",
    cost: 329.36,
    miles: 11,
    margin: 147.75,
    rate: 477.11,
    customerId: 60642,
    customerName: "Pregis LLC"
  },
  {
    loadId: 28011607,
    originCityId: 6436,
    originCityName: "Elk Grove Village",
    originStateCode: "IL",
    originLatitude: 41.988,
    originLongitude: -87.976,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-11-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 26,
    margin: 46,
    rate: 346,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 28000675,
    originCityId: 6087,
    originCityName: "Addison",
    originStateCode: "IL",
    originLatitude: 41.939,
    originLongitude: -88.033,
    destinationCityId: 1557398,
    destinationCityName: "Hodgkins",
    destinationStateCode: "IL",
    destinationLatitude: 41.818,
    destinationLongitude: -87.87,
    loadDate: "2022-11-15T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 181499,
    carrierName: "I V Brothers Corp",
    cost: 500,
    miles: 16,
    margin: 87.16,
    rate: 587.16,
    customerId: 7709,
    customerName: "Ferrara Candy Company"
  },
  {
    loadId: 27982715,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-11-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 32892,
    carrierName: "AN Enterprise, Inc.",
    cost: 400,
    miles: 3,
    margin: 10,
    rate: 410,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 28005945,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-11-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 365,
    miles: 30,
    margin: 140.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 27997698,
    originCityId: 7350,
    originCityName: "Wood Dale",
    originStateCode: "IL",
    originLatitude: 41.962,
    originLongitude: -87.96,
    destinationCityId: 6829,
    destinationCityName: "Melrose Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.91,
    destinationLongitude: -87.837,
    loadDate: "2022-11-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 466883,
    carrierName: "STEWIES TRUCKING TRANSPORTATION LLC",
    cost: 350,
    miles: 10,
    margin: 50,
    rate: 400,
    customerId: 53749,
    customerName: "D&W Fine Pack LLC"
  },
  {
    loadId: 27980243,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-11-14T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 219503,
    carrierName: "AG Carriers, Inc.",
    cost: 600,
    miles: 18,
    margin: 223.24,
    rate: 823.24,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 28004691,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-11-11T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 400,
    miles: 38,
    margin: 50,
    rate: 450,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27991753,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-11-11T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 186.5,
    rate: 486.5,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27941335,
    originCityId: 6436,
    originCityName: "Elk Grove Village",
    originStateCode: "IL",
    originLatitude: 41.988,
    originLongitude: -87.976,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-11-11T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 406740,
    carrierName: "Ahead Of Time Transport Inc",
    cost: 345,
    miles: 26,
    margin: 0,
    rate: 345,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 27957534,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-11-10T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 141506,
    carrierName: "Kalher Trucking, Inc.",
    cost: 525,
    miles: 18,
    margin: 298.29,
    rate: 823.29,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27987782,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-11-09T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 100,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27954199,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-11-07T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 409547,
    carrierName: "DBR INC",
    cost: 400,
    miles: 30,
    margin: 105.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 27937780,
    originCityId: 1558791,
    originCityName: "MT PROSPECT",
    originStateCode: "IL",
    originLatitude: 42.064,
    originLongitude: -87.937,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-11-07T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 222234,
    carrierName: "DMA Trucking, Inc.",
    cost: 275,
    miles: 30,
    margin: 60,
    rate: 335,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 27914935,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-11-07T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 550,
    miles: 24,
    margin: 30.77,
    rate: 580.77,
    customerId: 221622,
    customerName: "Lindt & Sprungli (North America) Inc. - BluJay"
  },
  {
    loadId: 27938559,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-11-04T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 38,
    margin: 100,
    rate: 450,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27914813,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-11-03T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 575,
    miles: 18,
    margin: 270.49,
    rate: 845.49,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27914810,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-11-03T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 575,
    miles: 18,
    margin: 270.49,
    rate: 845.49,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27904031,
    originCityId: 7174,
    originCityName: "South Holland",
    originStateCode: "IL",
    originLatitude: 41.6,
    originLongitude: -87.584,
    destinationCityId: 6269,
    destinationCityName: "Carol Stream",
    destinationStateCode: "IL",
    destinationLatitude: 41.904,
    destinationLongitude: -88.121,
    loadDate: "2022-11-03T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 83168,
    carrierName: "RTS Express, Inc.",
    cost: 600,
    miles: 44,
    margin: 150,
    rate: 750,
    customerId: 131337,
    customerName: "United Parcel Service Oasis Supply (COF)"
  },
  {
    loadId: 27928224,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6269,
    destinationCityName: "Carol Stream",
    destinationStateCode: "IL",
    destinationLatitude: 41.904,
    destinationLongitude: -88.121,
    loadDate: "2022-11-02T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 83168,
    carrierName: "RTS Express, Inc.",
    cost: 400,
    miles: 15,
    margin: 219,
    rate: 619,
    customerId: 92671,
    customerName: "The Kraft Heinz Company - CL77"
  },
  {
    loadId: 27924701,
    originCityId: 7327,
    originCityName: "Wheeling",
    originStateCode: "IL",
    originLatitude: 42.139,
    originLongitude: -87.91,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-11-02T00:00:00",
    equipmentTypes: [3, 6],
    rank: 203,
    carrierId: 6565,
    carrierName: "Midwest American Delivery Systems, Inc.",
    cost: 500,
    miles: 41,
    margin: 133.62,
    rate: 633.62,
    customerId: 72308,
    customerName: "G & W Electric Company"
  },
  {
    loadId: 27903982,
    originCityId: 7174,
    originCityName: "South Holland",
    originStateCode: "IL",
    originLatitude: 41.6,
    originLongitude: -87.584,
    destinationCityId: 6269,
    destinationCityName: "Carol Stream",
    destinationStateCode: "IL",
    destinationLatitude: 41.904,
    destinationLongitude: -88.121,
    loadDate: "2022-11-01T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 83168,
    carrierName: "RTS Express, Inc.",
    cost: 600,
    miles: 44,
    margin: 150,
    rate: 750,
    customerId: 131337,
    customerName: "United Parcel Service Oasis Supply (COF)"
  },
  {
    loadId: 27880613,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-11-01T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 171279,
    carrierName: "Alynevych, Inc.",
    cost: 500,
    miles: 24,
    margin: -64,
    rate: 436,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 27898818,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 7327,
    destinationCityName: "Wheeling",
    destinationStateCode: "IL",
    destinationLatitude: 42.139,
    destinationLongitude: -87.91,
    loadDate: "2022-10-31T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 7175,
    carrierName: "Windy City Carriers, Inc.",
    cost: 400,
    miles: 41,
    margin: 233.62,
    rate: 633.62,
    customerId: 72308,
    customerName: "G & W Electric Company"
  },
  {
    loadId: 27898190,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-10-31T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 253551,
    carrierName: "US Express Group, Inc.",
    cost: 400,
    miles: 27,
    margin: 250,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 27895512,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-10-31T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 385,
    miles: 30,
    margin: 120.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 27895460,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-10-31T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 380,
    miles: 30,
    margin: 125.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 27809665,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6541,
    destinationCityName: "Glenwood",
    destinationStateCode: "IL",
    destinationLatitude: 41.529,
    destinationLongitude: -87.589,
    loadDate: "2022-10-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 396217,
    carrierName: "M A DRUMMER LLC",
    cost: 500,
    miles: 27,
    margin: 400,
    rate: 900,
    customerId: 138637,
    customerName: "Morrison Container Handling Solutions"
  },
  {
    loadId: 27893967,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-10-28T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27869332,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2022-10-27T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 152424,
    carrierName: "DW Transport",
    cost: 325,
    miles: 18,
    margin: 7,
    rate: 332,
    customerId: 61312,
    customerName: "Woodbolt International"
  },
  {
    loadId: 27828282,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-10-27T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 472446,
    carrierName: "OK LOGISTIC 1 COMPANY",
    cost: 650,
    miles: 31,
    margin: -62.72,
    rate: 587.28,
    customerId: 221622,
    customerName: "Lindt & Sprungli (North America) Inc. - BluJay"
  },
  {
    loadId: 27854522,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-10-25T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 220293,
    carrierName: "Scorpion Express Logistics Corp",
    cost: 300,
    miles: 16,
    margin: 225,
    rate: 525,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27786515,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-10-24T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 343250,
    carrierName: "Sjt Trucking Inc",
    cost: 300,
    miles: 0,
    margin: 95,
    rate: 395,
    customerId: 61312,
    customerName: "Woodbolt International"
  },
  {
    loadId: 27842868,
    originCityId: 6829,
    originCityName: "Melrose Park",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.837,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-10-21T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 226179,
    carrierName: "Fox Transit Services Inc",
    cost: 300,
    miles: 12,
    margin: 200,
    rate: 500,
    customerId: 823,
    customerName: "Fattah Trading Company Inc"
  },
  {
    loadId: 27830876,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-10-21T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 83937,
    carrierName: "Yeifer Trucking, Inc",
    cost: 500,
    miles: 29,
    margin: 200,
    rate: 700,
    customerId: 180538,
    customerName: "Coast Beacon"
  },
  {
    loadId: 27821975,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-10-21T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 212322,
    carrierName: "RRC TRUCKING INC",
    cost: 350,
    miles: 16,
    margin: 250,
    rate: 600,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27819497,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-10-21T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 350,
    miles: 8,
    margin: 300,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 27819129,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-10-21T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 489631,
    carrierName: "GALACTICA TRANSPORTATION LLC",
    cost: 325,
    miles: 16,
    margin: 200,
    rate: 525,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27835750,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-10-20T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27812220,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-10-20T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 300891,
    carrierName: "Orchir Corporation",
    cost: 515,
    miles: 18,
    margin: 329.97,
    rate: 844.97,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27826828,
    originCityId: 6172,
    originCityName: "Bellwood",
    originStateCode: "IL",
    originLatitude: 41.886,
    originLongitude: -87.884,
    destinationCityId: 1557398,
    destinationCityName: "Hodgkins",
    destinationStateCode: "IL",
    destinationLatitude: 41.818,
    destinationLongitude: -87.87,
    loadDate: "2022-10-19T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 5,
    margin: 146.21,
    rate: 446.21,
    customerId: 7709,
    customerName: "Ferrara Candy Company"
  },
  {
    loadId: 27815312,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-10-19T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 360,
    miles: 30,
    margin: 145.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 27790741,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-10-19T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 396217,
    carrierName: "M A DRUMMER LLC",
    cost: 300,
    miles: 30,
    margin: 42.26,
    rate: 342.26,
    customerId: 61312,
    customerName: "Woodbolt International"
  },
  {
    loadId: 27790354,
    originCityId: 6436,
    originCityName: "Elk Grove Village",
    originStateCode: "IL",
    originLatitude: 41.988,
    originLongitude: -87.976,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-10-19T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 432314,
    carrierName: "INTEGRATED TRAVEL TRUCKING, INC.",
    cost: 300,
    miles: 36,
    margin: 67.68,
    rate: 367.68,
    customerId: 69847,
    customerName: "BWAY Corporation- USD"
  },
  {
    loadId: 27803651,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-10-18T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 117290,
    carrierName: "DKD Logistics, Inc.",
    cost: 550,
    miles: 0,
    margin: 100,
    rate: 650,
    customerId: 180538,
    customerName: "Coast Beacon"
  },
  {
    loadId: 27790850,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6123,
    destinationCityName: "Arlington Heights",
    destinationStateCode: "IL",
    destinationLatitude: 42.088,
    destinationLongitude: -87.981,
    loadDate: "2022-10-18T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 489631,
    carrierName: "GALACTICA TRANSPORTATION LLC",
    cost: 300,
    miles: 33,
    margin: 349.26,
    rate: 649.26,
    customerId: 61312,
    customerName: "Woodbolt International"
  },
  {
    loadId: 27790791,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-10-18T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 489631,
    carrierName: "GALACTICA TRANSPORTATION LLC",
    cost: 320,
    miles: 30,
    margin: 22.26,
    rate: 342.26,
    customerId: 61312,
    customerName: "Woodbolt International"
  },
  {
    loadId: 27805227,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-10-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27803494,
    originCityId: 6539,
    originCityName: "Glendale Heights",
    originStateCode: "IL",
    originLatitude: 41.857,
    originLongitude: -88.048,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-10-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 450,
    miles: 28,
    margin: 50,
    rate: 500,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27794235,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-10-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 295755,
    carrierName: "ELJIM Inc",
    cost: 350,
    miles: 16,
    margin: 250,
    rate: 600,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27793902,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-10-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 384524,
    carrierName: "Rogue Carrier Inc",
    cost: 350,
    miles: 16,
    margin: 175,
    rate: 525,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27791910,
    originCityId: 6541,
    originCityName: "Glenwood",
    originStateCode: "IL",
    originLatitude: 41.529,
    originLongitude: -87.589,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-10-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 424730,
    carrierName: "Mister C Inc",
    cost: 457,
    miles: 27,
    margin: 293,
    rate: 750,
    customerId: 138637,
    customerName: "Morrison Container Handling Solutions"
  },
  {
    loadId: 27791860,
    originCityId: 6541,
    originCityName: "Glenwood",
    originStateCode: "IL",
    originLatitude: 41.529,
    originLongitude: -87.589,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-10-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 445,
    miles: 27,
    margin: 305,
    rate: 750,
    customerId: 138637,
    customerName: "Morrison Container Handling Solutions"
  },
  {
    loadId: 27770870,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-10-17T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 300,
    miles: 10,
    margin: 186,
    rate: 486,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27793361,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-10-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27791375,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6213,
    destinationCityName: "Bridgeview",
    destinationStateCode: "IL",
    destinationLatitude: 41.75,
    destinationLongitude: -87.804,
    loadDate: "2022-10-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 13,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27786872,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-10-13T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27770871,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-10-13T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 186.1,
    rate: 486.1,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27757208,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-10-13T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 219503,
    carrierName: "AG Carriers, Inc.",
    cost: 600,
    miles: 18,
    margin: 246.84,
    rate: 846.84,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27747543,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-10-13T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 415844,
    carrierName: "AL YAKO TRUCKING INC",
    cost: 315,
    miles: 16,
    margin: 360,
    rate: 675,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27747382,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-10-13T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 212322,
    carrierName: "RRC TRUCKING INC",
    cost: 300,
    miles: 16,
    margin: 225,
    rate: 525,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27779042,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-10-12T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27751645,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-10-12T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 222098,
    carrierName: "MGL Star Corp",
    cost: 512.01,
    miles: 18,
    margin: 335.59,
    rate: 847.6,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27742072,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-10-11T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 186.2,
    rate: 486.2,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27733214,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-10-11T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 329514,
    carrierName: "CRR Transport LLC",
    cost: 350,
    miles: 29,
    margin: 45.3,
    rate: 395.3,
    customerId: 76749,
    customerName: "Anheuser-Busch Tier 2"
  },
  {
    loadId: 27724398,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2022-10-11T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 450748,
    carrierName: "RODRIGOS TRUCKING INC",
    cost: 300,
    miles: 14,
    margin: 75.84,
    rate: 375.84,
    customerId: 194505,
    customerName: "The Dow Chemical Company c/o XPO Logistics"
  },
  {
    loadId: 27738905,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-10-10T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 30,
    margin: 54,
    rate: 354,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 27738248,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-10-07T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 81363,
    carrierName: "Great Lakes Transportation, Inc.",
    cost: 346.79,
    miles: 30,
    margin: 151.39,
    rate: 498.18,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 27729150,
    originCityId: 6213,
    originCityName: "Bridgeview",
    originStateCode: "IL",
    originLatitude: 41.75,
    originLongitude: -87.804,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2022-10-06T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 329514,
    carrierName: "CRR Transport LLC",
    cost: 288.3,
    miles: 4,
    margin: 261.7,
    rate: 550,
    customerId: 168266,
    customerName: "Tersus Environmental LLC"
  },
  {
    loadId: 27718747,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-10-06T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 186.2,
    rate: 486.2,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27720554,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-10-05T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27671534,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6829,
    destinationCityName: "Melrose Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.91,
    destinationLongitude: -87.837,
    loadDate: "2022-10-05T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 159419,
    carrierName: "AK Trucking",
    cost: 700,
    miles: 12,
    margin: 0,
    rate: 700,
    customerId: 198628,
    customerName: "MDBC LLC / Mason Dixie Biscuit Co."
  },
  {
    loadId: 27563354,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-10-05T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 350,
    miles: 8,
    margin: 165,
    rate: 515,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 27707192,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6103,
    destinationCityName: "Alsip",
    destinationStateCode: "IL",
    destinationLatitude: 41.662,
    destinationLongitude: -87.738,
    loadDate: "2022-10-04T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 329514,
    carrierName: "CRR Transport LLC",
    cost: 383.39,
    miles: 24,
    margin: 116.61,
    rate: 500,
    customerId: 190443,
    customerName: "Willamette Falls Paper Company, Inc."
  },
  {
    loadId: 27697684,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-10-04T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 350,
    miles: 16,
    margin: 175,
    rate: 525,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27708223,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-10-03T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27706775,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-10-03T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27697470,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-10-03T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 350,
    miles: 16,
    margin: 175,
    rate: 525,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27683996,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-10-03T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 186.2,
    rate: 486.2,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27675826,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-10-03T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 550,
    miles: 18,
    margin: 288.27,
    rate: 838.27,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27675728,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-10-03T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 222098,
    carrierName: "MGL Star Corp",
    cost: 550,
    miles: 18,
    margin: 288.27,
    rate: 838.27,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27688505,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-09-30T00:00:00",
    equipmentTypes: [3],
    rank: 203,
    carrierId: 112166,
    carrierName: "Top Transport, Inc.",
    cost: 450,
    miles: 20,
    margin: 125,
    rate: 575,
    customerId: 41242,
    customerName: "Combilift USA LLC"
  },
  {
    loadId: 27673206,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-09-30T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 186.3,
    rate: 486.3,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27687487,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-09-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 100,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27683814,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-09-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 400,
    miles: 38,
    margin: 50,
    rate: 450,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27636510,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-09-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 41448,
    carrierName: "Experior Transport",
    cost: 350,
    miles: 16,
    margin: 175,
    rate: 525,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27661982,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-09-28T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 186.3,
    rate: 486.3,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27666708,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-09-27T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27663517,
    originCityId: 6436,
    originCityName: "Elk Grove Village",
    originStateCode: "IL",
    originLatitude: 41.988,
    originLongitude: -87.976,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-09-27T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 32468,
    carrierName: "Get Cargo, Inc.",
    cost: 415.64,
    miles: 49,
    margin: 274.36,
    rate: 690,
    customerId: 85,
    customerName: "Flint Group US LLC / Day International Group, Inc"
  },
  {
    loadId: 27639028,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-09-22T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27637702,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-09-22T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27623310,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-09-21T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 400,
    miles: 30,
    margin: 101.79,
    rate: 501.79,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 27622142,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-09-21T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 202932,
    carrierName: "Pride USA, Inc.",
    cost: 400,
    miles: 30,
    margin: 101.79,
    rate: 501.79,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 27617788,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-09-20T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27609989,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-09-20T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 300,
    miles: 10,
    margin: 185.9,
    rate: 485.9,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27598385,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-09-16T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27576352,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-09-16T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 460137,
    carrierName: "HOSON LOGISTICS AMERICA INC",
    cost: 350,
    miles: 16,
    margin: 125,
    rate: 475,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27523440,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 1557529,
    destinationCityName: "McCook",
    destinationStateCode: "IL",
    destinationLatitude: 41.798,
    destinationLongitude: -87.845,
    loadDate: "2022-09-16T00:00:00",
    equipmentTypes: [2],
    rank: 202,
    carrierId: 115114,
    carrierName: "Illinois Motor Express, Inc.",
    cost: 700,
    miles: 17.9,
    margin: 96.89,
    rate: 796.89,
    customerId: 65914,
    customerName: "LXP Armada"
  },
  {
    loadId: 27566238,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-09-13T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27560558,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-09-13T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185.9,
    rate: 485.9,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27560111,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-09-12T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185.9,
    rate: 485.9,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27556280,
    originCityId: 6829,
    originCityName: "Melrose Park",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.837,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-09-12T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 468087,
    carrierName: "A A A Cargo Trucks Inc",
    cost: 350,
    miles: 12,
    margin: 150,
    rate: 500,
    customerId: 823,
    customerName: "Fattah Trading Company Inc"
  },
  {
    loadId: 27529335,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-09-12T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 484117,
    carrierName: "NESUNCIA LOGISTICS",
    cost: 375,
    miles: 16,
    margin: 100,
    rate: 475,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27544669,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 7327,
    destinationCityName: "Wheeling",
    destinationStateCode: "IL",
    destinationLatitude: 42.139,
    destinationLongitude: -87.91,
    loadDate: "2022-09-09T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 400,
    miles: 28,
    margin: 75.68,
    rate: 475.68,
    customerId: 210537,
    customerName: "Richelieu Foods c/o Ryder - EDI"
  },
  {
    loadId: 27544395,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-09-09T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 186,
    rate: 486,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27533843,
    originCityId: 6436,
    originCityName: "Elk Grove Village",
    originStateCode: "IL",
    originLatitude: 41.988,
    originLongitude: -87.976,
    destinationCityId: 6176,
    destinationCityName: "Bensenville",
    destinationStateCode: "IL",
    destinationLatitude: 41.958,
    destinationLongitude: -87.918,
    loadDate: "2022-09-09T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 83937,
    carrierName: "Yeifer Trucking, Inc",
    cost: 550,
    miles: 4,
    margin: 102.92,
    rate: 652.92,
    customerId: 2299,
    customerName: "Hershey Company - CLLQ"
  },
  {
    loadId: 27539353,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-09-08T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 450,
    miles: 30,
    margin: 55.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 27491589,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-09-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 350,
    miles: 30,
    margin: 156.49,
    rate: 506.49,
    customerId: 11590,
    customerName: "Batory Foods / Chicago Sweeteners"
  },
  {
    loadId: 27528024,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-09-07T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 169980,
    carrierName: "JP Logistics, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27515961,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-09-06T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27514219,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-09-06T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27509701,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-09-06T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 350,
    miles: 31,
    margin: 131.15,
    rate: 481.15,
    customerId: 11590,
    customerName: "Batory Foods / Chicago Sweeteners"
  },
  {
    loadId: 27491237,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-09-02T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 385,
    miles: 30,
    margin: 120.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 27493439,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-09-01T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 500,
    miles: 30,
    margin: 5.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 27492992,
    originCityId: 7096,
    originCityName: "Roselle",
    originStateCode: "IL",
    originLatitude: 41.977,
    originLongitude: -88.076,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-09-01T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 400,
    miles: 39,
    margin: 50,
    rate: 450,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27480623,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-08-31T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27439784,
    originCityId: 29730,
    originCityName: "Northlake",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.904,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-08-30T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 211063,
    carrierName: "Royal Exchange Inc",
    cost: 400,
    miles: 12,
    margin: 250,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 27454175,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6487,
    destinationCityName: "Flossmoor",
    destinationStateCode: "IL",
    destinationLatitude: 41.523,
    destinationLongitude: -87.662,
    loadDate: "2022-08-29T00:00:00",
    equipmentTypes: [18],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 300,
    miles: 35,
    margin: 50,
    rate: 350,
    customerId: 163895,
    customerName: "Xtra Lease LLC - Midway"
  },
  {
    loadId: 27431930,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-08-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 186.3,
    rate: 486.3,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27428903,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-08-26T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 41448,
    carrierName: "Experior Transport",
    cost: 350,
    miles: 8,
    margin: 300,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 27418152,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-08-24T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 300,
    miles: 10,
    margin: 186.6,
    rate: 486.6,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27413529,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-08-24T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 471859,
    carrierName: "NA4 Trucking",
    cost: 390,
    miles: 30,
    margin: 109.99,
    rate: 499.99,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 27335396,
    originCityId: 6731,
    originCityName: "Lemont",
    originStateCode: "IL",
    originLatitude: 41.644,
    originLongitude: -87.99,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-08-24T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 298631,
    carrierName: "Tres RS Inc",
    cost: 350,
    miles: 32,
    margin: 49,
    rate: 399,
    customerId: 1102,
    customerName: "Meyer Steel Drum Inc."
  },
  {
    loadId: 27365987,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-08-23T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 206795,
    carrierName: "UMIDA INC",
    cost: 625,
    miles: 18,
    margin: 218.85,
    rate: 843.85,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27401935,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-08-22T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27383736,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-08-18T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27379493,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6885,
    destinationCityName: "Mount Prospect",
    destinationStateCode: "IL",
    destinationLatitude: 42.064,
    destinationLongitude: -87.937,
    loadDate: "2022-08-18T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 375,
    miles: 42,
    margin: 75,
    rate: 450,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27360145,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-08-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 186.9,
    rate: 486.9,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27361541,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-08-16T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27344730,
    originCityId: 29730,
    originCityName: "Northlake",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.904,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-08-16T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 202932,
    carrierName: "Pride USA, Inc.",
    cost: 400,
    miles: 12,
    margin: 250,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 27329972,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-08-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 490,
    carrierName: "Wynn's Freight Services, Inc.",
    cost: 300,
    miles: 16,
    margin: 195,
    rate: 495,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27329718,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-08-15T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 83937,
    carrierName: "Yeifer Trucking, Inc",
    cost: 700,
    miles: 18,
    margin: 142.3,
    rate: 842.3,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27324982,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-08-15T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 406740,
    carrierName: "Ahead Of Time Transport Inc",
    cost: 300,
    miles: 8,
    margin: 350,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 27329753,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-08-13T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 141506,
    carrierName: "Kalher Trucking, Inc.",
    cost: 650,
    miles: 18,
    margin: 191.1,
    rate: 841.1,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27339174,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-08-12T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 400,
    miles: 30,
    margin: 101.79,
    rate: 501.79,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 27329121,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 1557398,
    destinationCityName: "Hodgkins",
    destinationStateCode: "IL",
    destinationLatitude: 41.818,
    destinationLongitude: -87.87,
    loadDate: "2022-08-11T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 51651,
    carrierName: "IMG Trucking, Inc.",
    cost: 300,
    miles: 14,
    margin: 176.72,
    rate: 476.72,
    customerId: 11590,
    customerName: "Batory Foods / Chicago Sweeteners"
  },
  {
    loadId: 27327375,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-08-10T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27303951,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-08-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 187.2,
    rate: 487.2,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27299662,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-08-05T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 189887,
    carrierName: "Landliner, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27278192,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-08-05T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 325,
    miles: 16,
    margin: 170,
    rate: 495,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27287059,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-08-03T00:00:00",
    equipmentTypes: [18],
    rank: 201,
    carrierId: 150301,
    carrierName: "RP Trucking Solutions, Inc.",
    cost: 290,
    miles: 0,
    margin: 100,
    rate: 390,
    customerId: 160719,
    customerName: "UPS Owned Equipment Repositioning"
  },
  {
    loadId: 27281746,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-08-03T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 189887,
    carrierName: "Landliner, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27267067,
    originCityId: 29730,
    originCityName: "Northlake",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.904,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-08-03T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 343250,
    carrierName: "Sjt Trucking Inc",
    cost: 400,
    miles: 12,
    margin: 250,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 27264763,
    originCityId: 6398,
    originCityName: "Downers Grove",
    originStateCode: "IL",
    originLatitude: 41.809,
    originLongitude: -88.011,
    destinationCityId: 6213,
    destinationCityName: "Bridgeview",
    destinationStateCode: "IL",
    destinationLatitude: 41.75,
    destinationLongitude: -87.804,
    loadDate: "2022-08-02T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 300,
    miles: 15,
    margin: 260,
    rate: 560,
    customerId: 210180,
    customerName: "Point One International, Ltd."
  },
  {
    loadId: 27216323,
    originCityId: 6383,
    originCityName: "Des Plaines",
    originStateCode: "IL",
    originLatitude: 42.041,
    originLongitude: -87.888,
    destinationCityId: 6829,
    destinationCityName: "Melrose Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.91,
    destinationLongitude: -87.837,
    loadDate: "2022-08-02T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 80303,
    carrierName: "Real Trucking, Inc.",
    cost: 450,
    miles: 10,
    margin: 12.02,
    rate: 462.02,
    customerId: 536,
    customerName: "DSC Logistics, LLC"
  },
  {
    loadId: 27253426,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-07-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 187.6,
    rate: 487.6,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27250032,
    originCityId: 6829,
    originCityName: "Melrose Park",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.837,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-07-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 270337,
    carrierName: "EUGENE TRANSPORT INC",
    cost: 450,
    miles: 8,
    margin: 300,
    rate: 750,
    customerId: 4949,
    customerName: "Eastman Chemical Company"
  },
  {
    loadId: 27244158,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-07-28T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27241549,
    originCityId: 6436,
    originCityName: "Elk Grove Village",
    originStateCode: "IL",
    originLatitude: 41.988,
    originLongitude: -87.976,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2022-07-28T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 400,
    miles: 25,
    margin: 150,
    rate: 550,
    customerId: 168676,
    customerName: "Global Waste and Recycling LLC"
  },
  {
    loadId: 27232793,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-07-27T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27231486,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-07-27T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27221491,
    originCityId: 6829,
    originCityName: "Melrose Park",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.837,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-07-26T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 444129,
    carrierName: "STERLING LOGISTICS INC",
    cost: 300,
    miles: 12,
    margin: 200,
    rate: 500,
    customerId: 823,
    customerName: "Fattah Trading Company Inc"
  },
  {
    loadId: 27221476,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-07-26T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27217149,
    originCityId: 6829,
    originCityName: "Melrose Park",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.837,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-07-25T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 350,
    miles: 12,
    margin: 150,
    rate: 500,
    customerId: 823,
    customerName: "Fattah Trading Company Inc"
  },
  {
    loadId: 27208707,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6829,
    destinationCityName: "Melrose Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.91,
    destinationLongitude: -87.837,
    loadDate: "2022-07-25T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 189899,
    carrierName: "State Express Inc",
    cost: 400,
    miles: 19,
    margin: 130.39,
    rate: 530.39,
    customerId: 11590,
    customerName: "Batory Foods / Chicago Sweeteners"
  },
  {
    loadId: 27148493,
    originCityId: 29730,
    originCityName: "Northlake",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.904,
    destinationCityId: 6829,
    destinationCityName: "Melrose Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.91,
    destinationLongitude: -87.837,
    loadDate: "2022-07-25T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 369571,
    carrierName: "Bhupal Transportation, Inc.",
    cost: 500,
    miles: 4,
    margin: 13.94,
    rate: 513.94,
    customerId: 7709,
    customerName: "Ferrara Candy Company"
  },
  {
    loadId: 27194092,
    originCityId: 6193,
    originCityName: "Blue Island",
    originStateCode: "IL",
    originLatitude: 41.663,
    originLongitude: -87.679,
    destinationCityId: 6249,
    destinationCityName: "Calumet City",
    destinationStateCode: "IL",
    destinationLatitude: 41.601,
    destinationLongitude: -87.559,
    loadDate: "2022-07-22T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 187.6,
    rate: 487.6,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27185490,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-07-22T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27175563,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-07-22T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 387361,
    carrierName: "Royalty Truck Lines Inc",
    cost: 500,
    miles: 18,
    margin: 342.58,
    rate: 842.58,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27172487,
    originCityId: 6193,
    originCityName: "Blue Island",
    originStateCode: "IL",
    originLatitude: 41.663,
    originLongitude: -87.679,
    destinationCityId: 6249,
    destinationCityName: "Calumet City",
    destinationStateCode: "IL",
    destinationLatitude: 41.601,
    destinationLongitude: -87.559,
    loadDate: "2022-07-22T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27196497,
    originCityId: 6829,
    originCityName: "Melrose Park",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.837,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-07-21T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 270337,
    carrierName: "EUGENE TRANSPORT INC",
    cost: 350,
    miles: 12,
    margin: 250,
    rate: 600,
    customerId: 823,
    customerName: "Fattah Trading Company Inc"
  },
  {
    loadId: 27175539,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-07-21T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 83307,
    carrierName: "Silver Star Transportation, Inc.",
    cost: 700,
    miles: 18,
    margin: 142.75,
    rate: 842.75,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27173007,
    originCityId: 6193,
    originCityName: "Blue Island",
    originStateCode: "IL",
    originLatitude: 41.663,
    originLongitude: -87.679,
    destinationCityId: 6249,
    destinationCityName: "Calumet City",
    destinationStateCode: "IL",
    destinationLatitude: 41.601,
    destinationLongitude: -87.559,
    loadDate: "2022-07-21T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27173003,
    originCityId: 6193,
    originCityName: "Blue Island",
    originStateCode: "IL",
    originLatitude: 41.663,
    originLongitude: -87.679,
    destinationCityId: 6249,
    destinationCityName: "Calumet City",
    destinationStateCode: "IL",
    destinationLatitude: 41.601,
    destinationLongitude: -87.559,
    loadDate: "2022-07-21T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27187804,
    originCityId: 6193,
    originCityName: "Blue Island",
    originStateCode: "IL",
    originLatitude: 41.663,
    originLongitude: -87.679,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-07-20T00:00:00",
    equipmentTypes: [3],
    rank: 203,
    carrierId: 108961,
    carrierName: "AAA Brothers, LLC",
    cost: 450,
    miles: 19,
    margin: 75,
    rate: 525,
    customerId: 68549,
    customerName: "Amsted Rail Company, Inc."
  },
  {
    loadId: 27187703,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-07-20T00:00:00",
    equipmentTypes: [3],
    rank: 203,
    carrierId: 34662,
    carrierName: "Hot Rod Trucking Services, Inc.",
    cost: 400,
    miles: 18,
    margin: 145,
    rate: 545,
    customerId: 68549,
    customerName: "Amsted Rail Company, Inc."
  },
  {
    loadId: 27185487,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-07-20T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27184125,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-07-20T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 411243,
    carrierName: "Lit Group Inc",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27173008,
    originCityId: 6193,
    originCityName: "Blue Island",
    originStateCode: "IL",
    originLatitude: 41.663,
    originLongitude: -87.679,
    destinationCityId: 6249,
    destinationCityName: "Calumet City",
    destinationStateCode: "IL",
    destinationLatitude: 41.601,
    destinationLongitude: -87.559,
    loadDate: "2022-07-20T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27170105,
    originCityId: 6193,
    originCityName: "Blue Island",
    originStateCode: "IL",
    originLatitude: 41.663,
    originLongitude: -87.679,
    destinationCityId: 6249,
    destinationCityName: "Calumet City",
    destinationStateCode: "IL",
    destinationLatitude: 41.601,
    destinationLongitude: -87.559,
    loadDate: "2022-07-20T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27162552,
    originCityId: 7350,
    originCityName: "Wood Dale",
    originStateCode: "IL",
    originLatitude: 41.962,
    originLongitude: -87.96,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-07-19T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 400,
    miles: 22,
    margin: 300,
    rate: 700,
    customerId: 233485,
    customerName: "Chicago Welding & Fabrication Corporation"
  },
  {
    loadId: 27153063,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-07-19T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 219503,
    carrierName: "AG Carriers, Inc.",
    cost: 700,
    miles: 18,
    margin: -27.96,
    rate: 672.04,
    customerId: 92671,
    customerName: "The Kraft Heinz Company - CL77"
  },
  {
    loadId: 27140791,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-07-18T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 300,
    miles: 10,
    margin: 192.2,
    rate: 492.2,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27160088,
    originCityId: 6829,
    originCityName: "Melrose Park",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.837,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-07-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 253693,
    carrierName: "Dignity Logistics Inc",
    cost: 350,
    miles: 12,
    margin: 150,
    rate: 500,
    customerId: 823,
    customerName: "Fattah Trading Company Inc"
  },
  {
    loadId: 27138832,
    originCityId: 6193,
    originCityName: "Blue Island",
    originStateCode: "IL",
    originLatitude: 41.663,
    originLongitude: -87.679,
    destinationCityId: 6249,
    destinationCityName: "Calumet City",
    destinationStateCode: "IL",
    destinationLatitude: 41.601,
    destinationLongitude: -87.559,
    loadDate: "2022-07-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27142678,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-07-13T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27137013,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-07-13T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 375,
    miles: 8,
    margin: 275,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 27120258,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-07-13T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27134114,
    originCityId: 29730,
    originCityName: "Northlake",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.904,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-07-12T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 169980,
    carrierName: "JP Logistics, Inc.",
    cost: 450,
    miles: 12,
    margin: 200,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 27134025,
    originCityId: 6383,
    originCityName: "Des Plaines",
    originStateCode: "IL",
    originLatitude: 42.041,
    originLongitude: -87.888,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-07-12T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 106912,
    carrierName: "TransRapid, Inc.",
    cost: 350,
    miles: 20,
    margin: 450,
    rate: 800,
    customerId: 102580,
    customerName: "Upton's Naturals"
  },
  {
    loadId: 27108992,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-07-11T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 343250,
    carrierName: "Sjt Trucking Inc",
    cost: 450,
    miles: 28,
    margin: 159.78,
    rate: 609.78,
    customerId: 60642,
    customerName: "Pregis LLC"
  },
  {
    loadId: 27092162,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2022-07-11T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 387361,
    carrierName: "Royalty Truck Lines Inc",
    cost: 400,
    miles: 14,
    margin: 130,
    rate: 530,
    customerId: 215220,
    customerName: "Toennies USA, Inc."
  },
  {
    loadId: 27112072,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-07-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 8,
    margin: 50,
    rate: 400,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27107000,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6503,
    destinationCityName: "Franklin Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.949,
    destinationLongitude: -87.878,
    loadDate: "2022-07-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 222558,
    carrierName: "AMG Logistics, Inc.",
    cost: 426,
    miles: 19,
    margin: 275.02,
    rate: 701.02,
    customerId: 226275,
    customerName: "Joe Fresh Goods Inc"
  },
  {
    loadId: 27044611,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-07-08T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 600,
    miles: 18,
    margin: 244.67,
    rate: 844.67,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27108544,
    originCityId: 7096,
    originCityName: "Roselle",
    originStateCode: "IL",
    originLatitude: 41.977,
    originLongitude: -88.076,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2022-07-07T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 28,
    margin: 0,
    rate: 350,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27102008,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-07-07T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 8,
    margin: 150,
    rate: 450,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27096725,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2022-07-07T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 550,
    miles: 14,
    margin: 150,
    rate: 700,
    customerId: 180538,
    customerName: "Coast Beacon"
  },
  {
    loadId: 27044610,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-07-07T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 83307,
    carrierName: "Silver Star Transportation, Inc.",
    cost: 600,
    miles: 18,
    margin: 240.99,
    rate: 840.99,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27097064,
    originCityId: 7819,
    originCityName: "Munster",
    originStateCode: "IN",
    originLatitude: 41.568,
    originLongitude: -87.508,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-07-06T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 219503,
    carrierName: "AG Carriers, Inc.",
    cost: 650,
    miles: 25,
    margin: 345,
    rate: 995,
    customerId: 45043,
    customerName: "Carl Buddig and Company"
  },
  {
    loadId: 27092345,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-07-06T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27071404,
    originCityId: 29730,
    originCityName: "Northlake",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.904,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-07-06T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 406740,
    carrierName: "Ahead Of Time Transport Inc",
    cost: 400,
    miles: 12,
    margin: 250,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 27067831,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-07-06T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 400,
    miles: 8,
    margin: 132.95,
    rate: 532.95,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27035516,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-07-06T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 550,
    miles: 18,
    margin: 292.9,
    rate: 842.9,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 27009111,
    originCityId: 6829,
    originCityName: "Melrose Park",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.837,
    destinationCityId: 6176,
    destinationCityName: "Bensenville",
    destinationStateCode: "IL",
    destinationLatitude: 41.958,
    destinationLongitude: -87.918,
    loadDate: "2022-07-01T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 450629,
    carrierName: "1 Blessed Transportation Inc",
    cost: 500,
    miles: 8.6,
    margin: -49.06,
    rate: 450.94,
    customerId: 63271,
    customerName: "US Foods - Manhattan"
  },
  {
    loadId: 27027073,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-06-30T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 300,
    miles: 0,
    margin: 300,
    rate: 600,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 27053183,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-06-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 400,
    miles: 17,
    margin: 100,
    rate: 500,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27031286,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-06-27T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 27029262,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-06-24T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 400,
    miles: 8,
    margin: 50,
    rate: 450,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 27002044,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-06-24T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 26997122,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2022-06-24T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 400,
    miles: 18,
    margin: 225,
    rate: 625,
    customerId: 168266,
    customerName: "Tersus Environmental LLC"
  },
  {
    loadId: 27006127,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-06-22T00:00:00",
    equipmentTypes: [3, 29],
    rank: 203,
    carrierId: 397069,
    carrierName: "DREAMVILLE TRUCKING COMPANY",
    cost: 600,
    miles: 15,
    margin: 100,
    rate: 700,
    customerId: 19940,
    customerName: "Karay Metals Inc."
  },
  {
    loadId: 27000770,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-06-21T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 400,
    miles: 8,
    margin: 50,
    rate: 450,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26939841,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-06-20T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 377209,
    carrierName: "Rightway Inc",
    cost: 625,
    miles: 18,
    margin: 226.9,
    rate: 851.9,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26982041,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-06-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 400,
    miles: 8,
    margin: 100,
    rate: 500,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26959717,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-06-17T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 199824,
    carrierName: "WJK Trans, Inc.",
    cost: 500,
    miles: 0,
    margin: 95,
    rate: 595,
    customerId: 215220,
    customerName: "Toennies USA, Inc."
  },
  {
    loadId: 26942684,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-06-17T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 222098,
    carrierName: "MGL Star Corp",
    cost: 450,
    miles: 5,
    margin: 62,
    rate: 512,
    customerId: 7709,
    customerName: "Ferrara Candy Company"
  },
  {
    loadId: 26960099,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6654,
    destinationCityName: "Itasca",
    destinationStateCode: "IL",
    destinationLatitude: 41.971,
    destinationLongitude: -88.018,
    loadDate: "2022-06-16T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 473448,
    carrierName: "MOORE BETTER TRANSPORTATION",
    cost: 350,
    miles: 24,
    margin: 212.04,
    rate: 562.04,
    customerId: 82032,
    customerName: "Ingredion Incorporated / Corn Products Intl."
  },
  {
    loadId: 26951721,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2022-06-16T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 398150,
    carrierName: "B LINE FREIGHT INC",
    cost: 414.38,
    miles: 14,
    margin: 165.62,
    rate: 580,
    customerId: 215220,
    customerName: "Toennies USA, Inc."
  },
  {
    loadId: 26942682,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-06-16T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 142499,
    carrierName: "EU Autos, Inc.",
    cost: 450,
    miles: 5,
    margin: 62,
    rate: 512,
    customerId: 7709,
    customerName: "Ferrara Candy Company"
  },
  {
    loadId: 26942681,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-06-16T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 200288,
    carrierName: "Turbo Trans, Inc",
    cost: 450,
    miles: 5,
    margin: 62,
    rate: 512,
    customerId: 7709,
    customerName: "Ferrara Candy Company"
  },
  {
    loadId: 26942680,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-06-16T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 142499,
    carrierName: "EU Autos, Inc.",
    cost: 450,
    miles: 5,
    margin: 61.92,
    rate: 511.92,
    customerId: 7709,
    customerName: "Ferrara Candy Company"
  },
  {
    loadId: 26964061,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-06-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 400,
    miles: 8,
    margin: 50,
    rate: 450,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26949059,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-06-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 26939915,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-06-15T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 615,
    miles: 18,
    margin: 237.22,
    rate: 852.22,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26908248,
    originCityId: 6758,
    originCityName: "Lombard",
    originStateCode: "IL",
    originLatitude: 41.889,
    originLongitude: -88.028,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-06-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 211063,
    carrierName: "Royal Exchange Inc",
    cost: 400,
    miles: 23,
    margin: 255,
    rate: 655,
    customerId: 49683,
    customerName: "Audit Logistics, LLC"
  },
  {
    loadId: 26908222,
    originCityId: 6758,
    originCityName: "Lombard",
    originStateCode: "IL",
    originLatitude: 41.889,
    originLongitude: -88.028,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-06-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 211063,
    carrierName: "Royal Exchange Inc",
    cost: 400,
    miles: 23,
    margin: 255,
    rate: 655,
    customerId: 49683,
    customerName: "Audit Logistics, LLC"
  },
  {
    loadId: 26918708,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-06-10T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 26925172,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-06-09T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 275181,
    carrierName: "Mon Pride Express, Inc.",
    cost: 500,
    miles: 30,
    margin: 125,
    rate: 625,
    customerId: 823,
    customerName: "Fattah Trading Company Inc"
  },
  {
    loadId: 26916660,
    originCityId: 6218,
    originCityName: "Broadview",
    originStateCode: "IL",
    originLatitude: 41.876,
    originLongitude: -87.832,
    destinationCityId: 6176,
    destinationCityName: "Bensenville",
    destinationStateCode: "IL",
    destinationLatitude: 41.958,
    destinationLongitude: -87.918,
    loadDate: "2022-06-09T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 206795,
    carrierName: "UMIDA INC",
    cost: 800,
    miles: 13.6,
    margin: 3.99,
    rate: 803.99,
    customerId: 63271,
    customerName: "US Foods - Manhattan"
  },
  {
    loadId: 26922969,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-06-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 400,
    miles: 8,
    margin: 100,
    rate: 500,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26914270,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-06-08T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 400,
    miles: 29,
    margin: 250,
    rate: 650,
    customerId: 53135,
    customerName: "Global CPG, LLC"
  },
  {
    loadId: 26910679,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-06-07T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 400,
    miles: 8,
    margin: 100,
    rate: 500,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26896371,
    originCityId: 6179,
    originCityName: "Berkeley",
    originStateCode: "IL",
    originLatitude: 41.903,
    originLongitude: -87.903,
    destinationCityId: 6176,
    destinationCityName: "Bensenville",
    destinationStateCode: "IL",
    destinationLatitude: 41.958,
    destinationLongitude: -87.918,
    loadDate: "2022-06-07T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 83937,
    carrierName: "Yeifer Trucking, Inc",
    cost: 550,
    miles: 8.6,
    margin: 40.57,
    rate: 590.57,
    customerId: 63271,
    customerName: "US Foods - Manhattan"
  },
  {
    loadId: 26893958,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-06-06T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 420,
    miles: 30,
    margin: 85.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 26886334,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-06-06T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 300,
    miles: 10,
    margin: 185,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 26874226,
    originCityId: 1557529,
    originCityName: "McCook",
    originStateCode: "IL",
    originLatitude: 41.798,
    originLongitude: -87.845,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-06-03T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 112938,
    carrierName: "T & D Transportation Services Inc",
    cost: 400,
    miles: 18,
    margin: 245,
    rate: 645,
    customerId: 183163,
    customerName: "Magic Spoon Inc."
  },
  {
    loadId: 26872615,
    originCityId: 1557529,
    originCityName: "McCook",
    originStateCode: "IL",
    originLatitude: 41.798,
    originLongitude: -87.845,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-06-03T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 395822,
    carrierName: "Relentless Trucking LLC",
    cost: 355.92,
    miles: 18,
    margin: 289.08,
    rate: 645,
    customerId: 183163,
    customerName: "Magic Spoon Inc."
  },
  {
    loadId: 26846489,
    originCityId: 29730,
    originCityName: "Northlake",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.904,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-06-02T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 270337,
    carrierName: "EUGENE TRANSPORT INC",
    cost: 500,
    miles: 12,
    margin: 150,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 26846482,
    originCityId: 29730,
    originCityName: "Northlake",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.904,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-06-02T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 211063,
    carrierName: "Royal Exchange Inc",
    cost: 500,
    miles: 12,
    margin: 150,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 26862595,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-05-31T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 400,
    miles: 8,
    margin: 100,
    rate: 500,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26855189,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-05-31T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 10,
    margin: 135,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 26843716,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-05-31T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 328785,
    carrierName: "PPT LLC",
    cost: 600,
    miles: 18,
    margin: 245.69,
    rate: 845.69,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26841107,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-05-31T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 219503,
    carrierName: "AG Carriers, Inc.",
    cost: 650,
    miles: 18,
    margin: 195.69,
    rate: 845.69,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26826084,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-05-27T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 10,
    margin: 135,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 26815499,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6503,
    destinationCityName: "Franklin Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.949,
    destinationLongitude: -87.878,
    loadDate: "2022-05-27T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 500,
    miles: 19,
    margin: 575,
    rate: 1075,
    customerId: 141962,
    customerName: "Sirman USA, Inc"
  },
  {
    loadId: 26831221,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 1557417,
    destinationCityName: "Summit",
    destinationStateCode: "IL",
    destinationLatitude: 41.781,
    destinationLongitude: -87.826,
    loadDate: "2022-05-26T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 176457,
    carrierName: "Black Sea Transportation, LLC",
    cost: 650,
    miles: 28,
    margin: 368.37,
    rate: 1018.37,
    customerId: 76500,
    customerName: "Ace Hardware Corporation"
  },
  {
    loadId: 26829518,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-05-25T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 10,
    margin: 135,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 26821956,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-05-25T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 400,
    miles: 8,
    margin: 100,
    rate: 500,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26819093,
    originCityId: 1557529,
    originCityName: "McCook",
    originStateCode: "IL",
    originLatitude: 41.798,
    originLongitude: -87.845,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-05-25T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 406904,
    carrierName: "USA Trans Inc",
    cost: 300,
    miles: 18,
    margin: 345,
    rate: 645,
    customerId: 183163,
    customerName: "Magic Spoon Inc."
  },
  {
    loadId: 26807104,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-05-25T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 290747,
    carrierName: "Direct Motor Lines Inc",
    cost: 745,
    miles: 18,
    margin: 98.03,
    rate: 843.03,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26821955,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-05-24T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 400,
    miles: 8,
    margin: 100,
    rate: 500,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26816565,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-05-24T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 10,
    margin: 135,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 26816563,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-05-24T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 350,
    miles: 10,
    margin: 135,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 26816085,
    originCityId: 1557400,
    originCityName: "Burr Ridge",
    originStateCode: "IL",
    originLatitude: 41.74,
    originLongitude: -87.917,
    destinationCityId: 7323,
    destinationCityName: "Westmont",
    destinationStateCode: "IL",
    destinationLatitude: 41.759,
    destinationLongitude: -87.954,
    loadDate: "2022-05-24T00:00:00",
    equipmentTypes: [3],
    rank: 203,
    carrierId: 208192,
    carrierName: "Walsh Logistics INC",
    cost: 600,
    miles: 5,
    margin: 350,
    rate: 950,
    customerId: 159457,
    customerName: "Container Systems, Inc."
  },
  {
    loadId: 26805738,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 6103,
    destinationCityName: "Alsip",
    destinationStateCode: "IL",
    destinationLatitude: 41.662,
    destinationLongitude: -87.738,
    loadDate: "2022-05-23T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 107358,
    carrierName: "New Way Transportation, Inc.",
    cost: 350,
    miles: 11,
    margin: 315,
    rate: 665,
    customerId: 40849,
    customerName: "Chemsol, LLC"
  },
  {
    loadId: 26789104,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-05-19T00:00:00",
    equipmentTypes: [1, 2],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 450,
    miles: 29,
    margin: 250,
    rate: 700,
    customerId: 53135,
    customerName: "Global CPG, LLC"
  },
  {
    loadId: 26763161,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-05-19T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 141506,
    carrierName: "Kalher Trucking, Inc.",
    cost: 575,
    miles: 18,
    margin: 266.81,
    rate: 841.81,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26779144,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6503,
    destinationCityName: "Franklin Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.949,
    destinationLongitude: -87.878,
    loadDate: "2022-05-18T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 424558,
    carrierName: "OTF EXPRESS INC",
    cost: 350,
    miles: 19,
    margin: 294,
    rate: 644,
    customerId: 226275,
    customerName: "Joe Fresh Goods Inc"
  },
  {
    loadId: 26756858,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-05-18T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 83307,
    carrierName: "Silver Star Transportation, Inc.",
    cost: 550,
    miles: 18,
    margin: 293.22,
    rate: 843.22,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26761404,
    originCityId: 1557529,
    originCityName: "McCook",
    originStateCode: "IL",
    originLatitude: 41.798,
    originLongitude: -87.845,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-05-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 34448,
    carrierName: "Midwest Star Group, Inc.",
    cost: 300,
    miles: 18,
    margin: 345,
    rate: 645,
    customerId: 183163,
    customerName: "Magic Spoon Inc."
  },
  {
    loadId: 26741565,
    originCityId: 6503,
    originCityName: "Franklin Park",
    originStateCode: "IL",
    originLatitude: 41.949,
    originLongitude: -87.878,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-05-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 211063,
    carrierName: "Royal Exchange Inc",
    cost: 500,
    miles: 18,
    margin: 575,
    rate: 1075,
    customerId: 141962,
    customerName: "Sirman USA, Inc"
  },
  {
    loadId: 26745658,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-05-13T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 270337,
    carrierName: "EUGENE TRANSPORT INC",
    cost: 475,
    miles: 8,
    margin: 175,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 26731495,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-05-13T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 350,
    miles: 10,
    margin: 135,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 26622205,
    originCityId: 7355,
    originCityName: "Woodridge",
    originStateCode: "IL",
    originLatitude: 41.738,
    originLongitude: -88.028,
    destinationCityId: 6269,
    destinationCityName: "Carol Stream",
    destinationStateCode: "IL",
    destinationLatitude: 41.904,
    destinationLongitude: -88.121,
    loadDate: "2022-05-13T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 600,
    miles: 18,
    margin: 253.7,
    rate: 853.7,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26747884,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-05-12T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 34448,
    carrierName: "Midwest Star Group, Inc.",
    cost: 350,
    miles: 8,
    margin: 150,
    rate: 500,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26734921,
    originCityId: 7096,
    originCityName: "Roselle",
    originStateCode: "IL",
    originLatitude: 41.977,
    originLongitude: -88.076,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-05-11T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 400,
    miles: 39,
    margin: 150,
    rate: 550,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26724582,
    originCityId: 6829,
    originCityName: "Melrose Park",
    originStateCode: "IL",
    originLatitude: 41.91,
    originLongitude: -87.837,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-05-11T00:00:00",
    equipmentTypes: [3],
    rank: 203,
    carrierId: 400848,
    carrierName: "MID-I TRANSPORT LLC",
    cost: 750,
    miles: 27,
    margin: 250,
    rate: 1000,
    customerId: 159457,
    customerName: "Container Systems, Inc."
  },
  {
    loadId: 26712768,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-05-11T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 185303,
    carrierName: "Easy and Quick Trans Inc",
    cost: 570.32,
    miles: 18,
    margin: 274.11,
    rate: 844.43,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26712731,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-05-11T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 208507,
    carrierName: "A R Logistics 29 Corp",
    cost: 550,
    miles: 18,
    margin: 294.43,
    rate: 844.43,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26730398,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-05-10T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 400,
    miles: 17,
    margin: 100,
    rate: 500,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26722110,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-05-10T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 287560,
    carrierName: "Recycling Materials, Inc.",
    cost: 420,
    miles: 30,
    margin: 85.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 26713212,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-05-09T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 6726,
    carrierName: "W2 Logistic, Inc.",
    cost: 650,
    miles: 24,
    margin: 365,
    rate: 1015,
    customerId: 60923,
    customerName: "Unilever NASCC"
  },
  {
    loadId: 26693292,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-05-09T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 219503,
    carrierName: "AG Carriers, Inc.",
    cost: 500,
    miles: 15,
    margin: 50,
    rate: 550,
    customerId: 215220,
    customerName: "Toennies USA, Inc."
  },
  {
    loadId: 26686672,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6193,
    destinationCityName: "Blue Island",
    destinationStateCode: "IL",
    destinationLatitude: 41.663,
    destinationLongitude: -87.679,
    loadDate: "2022-05-06T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 350,
    miles: 10,
    margin: 135,
    rate: 485,
    customerId: 10065,
    customerName: "Rhodia"
  },
  {
    loadId: 26704733,
    originCityId: 7132,
    originCityName: "Schiller Park",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.872,
    destinationCityId: 7096,
    destinationCityName: "Roselle",
    destinationStateCode: "IL",
    destinationLatitude: 41.977,
    destinationLongitude: -88.076,
    loadDate: "2022-05-05T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 445148,
    carrierName: "PV FREIGHT INC",
    cost: 300,
    miles: 12,
    margin: 125,
    rate: 425,
    customerId: 26523,
    customerName: "NOW Health Group, Inc."
  },
  {
    loadId: 26680473,
    originCityId: 6503,
    originCityName: "Franklin Park",
    originStateCode: "IL",
    originLatitude: 41.949,
    originLongitude: -87.878,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-05-04T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 400,
    miles: 18,
    margin: 250,
    rate: 650,
    customerId: 226275,
    customerName: "Joe Fresh Goods Inc"
  },
  {
    loadId: 26663955,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-05-04T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 434122,
    carrierName: "SAHOTA TRANSPORTATION LLC",
    cost: 600,
    miles: 18,
    margin: 246.22,
    rate: 846.22,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26673996,
    originCityId: 6539,
    originCityName: "Glendale Heights",
    originStateCode: "IL",
    originLatitude: 41.857,
    originLongitude: -88.048,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-05-02T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 400,
    miles: 28,
    margin: 150,
    rate: 550,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26666530,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-04-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 500,
    miles: 17,
    margin: 0,
    rate: 500,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26665649,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-04-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 450,
    miles: 8,
    margin: 200,
    rate: 650,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26648550,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-04-29T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 203887,
    carrierName: "Get It Done Trucking LLC",
    cost: 500,
    miles: 0,
    margin: 250,
    rate: 750,
    customerId: 180538,
    customerName: "Coast Beacon"
  },
  {
    loadId: 26656279,
    originCityId: 6539,
    originCityName: "Glendale Heights",
    originStateCode: "IL",
    originLatitude: 41.857,
    originLongitude: -88.048,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-04-28T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 500,
    miles: 28,
    margin: 200,
    rate: 700,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26624979,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-04-28T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 225326,
    carrierName: "Roma Logistics Inc",
    cost: 550,
    miles: 29,
    margin: 200,
    rate: 750,
    customerId: 221622,
    customerName: "Lindt & Sprungli (North America) Inc. - BluJay"
  },
  {
    loadId: 26618299,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-04-28T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 223314,
    carrierName: "Rolling Stones Logistics Inc",
    cost: 526.3,
    miles: 18,
    margin: 317.72,
    rate: 844.02,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26644774,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-04-27T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 400,
    miles: 0,
    margin: 100,
    rate: 500,
    customerId: 158447,
    customerName: "IBC Tote Recycling LLC"
  },
  {
    loadId: 26644189,
    originCityId: 6654,
    originCityName: "Itasca",
    originStateCode: "IL",
    originLatitude: 41.971,
    originLongitude: -88.018,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-04-27T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 21466,
    carrierName: "Merx Global, Inc.",
    cost: 600,
    miles: 45,
    margin: 379.25,
    rate: 979.25,
    customerId: 67674,
    customerName: "The Valspar Corporation/Sherwin Williams"
  },
  {
    loadId: 26634298,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-26T00:00:00",
    equipmentTypes: [1, 2],
    rank: 202,
    carrierId: 298631,
    carrierName: "Tres RS Inc",
    cost: 358.43,
    miles: 38,
    margin: 337.91,
    rate: 696.34,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26633241,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-04-26T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 205764,
    carrierName: "Capital Freight Logistics, Inc.",
    cost: 465,
    miles: 30,
    margin: 40.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 26600224,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-04-26T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 401855,
    carrierName: "Dogstone Logistics, LLC",
    cost: 300,
    miles: 4,
    margin: 255,
    rate: 555,
    customerId: 4795,
    customerName: "National Container Group, LLC"
  },
  {
    loadId: 26628869,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-04-25T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 331081,
    carrierName: "Phoenix Carriers, LLC.",
    cost: 400,
    miles: 0,
    margin: 80,
    rate: 480,
    customerId: 68849,
    customerName: "Blommer Chocolate (IL)"
  },
  {
    loadId: 26628012,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-25T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 176457,
    carrierName: "Black Sea Transportation, LLC",
    cost: 550,
    miles: 20,
    margin: -550,
    rate: 0,
    customerId: 224612,
    customerName: "International Flavors & Fragrances Inc. - APL/Trax"
  },
  {
    loadId: 26623274,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-25T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 444004,
    carrierName: "GRISBY TRUCKING LLC",
    cost: 400,
    miles: 38,
    margin: 301.18,
    rate: 701.18,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26623272,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-25T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 401681,
    carrierName: "M & J Group Trucking Inc",
    cost: 400,
    miles: 38,
    margin: 297.62,
    rate: 697.62,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26565085,
    originCityId: 8085,
    originCityName: "Whiting",
    originStateCode: "IN",
    originLatitude: 41.663,
    originLongitude: -87.48,
    destinationCityId: 7044,
    destinationCityName: "Prospect Heights",
    destinationStateCode: "IL",
    destinationLatitude: 42.095,
    destinationLongitude: -87.934,
    loadDate: "2022-04-25T00:00:00",
    equipmentTypes: [28, 8],
    rank: 203,
    carrierId: 8208,
    carrierName: "Family Tradition, LLC",
    cost: 3500,
    miles: 44,
    margin: -750,
    rate: 2750,
    customerId: 10835,
    customerName: "Gray Machinery Co."
  },
  {
    loadId: 26615147,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-22T00:00:00",
    equipmentTypes: [1, 2],
    rank: 202,
    carrierId: 305311,
    carrierName: "Go Neal Logistics Incorporated",
    cost: 400,
    miles: 38,
    margin: 216.34,
    rate: 616.34,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26615144,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-22T00:00:00",
    equipmentTypes: [1, 2],
    rank: 202,
    carrierId: 296587,
    carrierName: "Magi Truck, Inc.",
    cost: 400,
    miles: 38,
    margin: 296.34,
    rate: 696.34,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26605078,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-04-22T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 416066,
    carrierName: "JCC Trucking Services Inc",
    cost: 375,
    miles: 20,
    margin: 100,
    rate: 475,
    customerId: 65787,
    customerName: "Brooklyn Bottling of Milton, New York, Inc."
  },
  {
    loadId: 26572182,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-04-22T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 218912,
    carrierName: "BLG Express, Inc.",
    cost: 550,
    miles: 18,
    margin: 293.08,
    rate: 843.08,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26577327,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-04-21T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 294284,
    carrierName: "RM Lines Inc",
    cost: 800,
    miles: 18,
    margin: 42.42,
    rate: 842.42,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26570154,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-04-21T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 203887,
    carrierName: "Get It Done Trucking LLC",
    cost: 728.38,
    miles: 45,
    margin: 65.51,
    rate: 793.89,
    customerId: 221622,
    customerName: "Lindt & Sprungli (North America) Inc. - BluJay"
  },
  {
    loadId: 26599059,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-04-20T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 450,
    miles: 8,
    margin: 200,
    rate: 650,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26598857,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-04-20T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 450,
    miles: 8,
    margin: 200,
    rate: 650,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26596781,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6269,
    destinationCityName: "Carol Stream",
    destinationStateCode: "IL",
    destinationLatitude: 41.904,
    destinationLongitude: -88.121,
    loadDate: "2022-04-20T00:00:00",
    equipmentTypes: [18],
    rank: 203,
    carrierId: 450529,
    carrierName: "NATIONAL FREIGHT TRANSPORTATION INC",
    cost: 300,
    miles: 31,
    margin: 0,
    rate: 300,
    customerId: 163895,
    customerName: "Xtra Lease LLC - Midway"
  },
  {
    loadId: 26570156,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-04-20T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 222098,
    carrierName: "MGL Star Corp",
    cost: 808.08,
    miles: 45,
    margin: -14.66,
    rate: 793.42,
    customerId: 221622,
    customerName: "Lindt & Sprungli (North America) Inc. - BluJay"
  },
  {
    loadId: 26591737,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 7096,
    destinationCityName: "Roselle",
    destinationStateCode: "IL",
    destinationLatitude: 41.977,
    destinationLongitude: -88.076,
    loadDate: "2022-04-19T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 500,
    miles: 45,
    margin: 200,
    rate: 700,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26585056,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-19T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 400,
    miles: 38,
    margin: 297.62,
    rate: 697.62,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26585055,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-19T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 218912,
    carrierName: "BLG Express, Inc.",
    cost: 400,
    miles: 38,
    margin: 216.34,
    rate: 616.34,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26550028,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-04-14T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 421097,
    carrierName: "JNR TRANSPORT INC",
    cost: 450,
    miles: 8,
    margin: 200,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 26529597,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-04-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 199721,
    carrierName: "MTZ Trucking Services, Inc.",
    cost: 600,
    miles: 12,
    margin: 229.84,
    rate: 829.84,
    customerId: 9994,
    customerName: "S. C. Johnson & Son, Inc. - BluJay"
  },
  {
    loadId: 26550837,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-13T00:00:00",
    equipmentTypes: [1, 2],
    rank: 202,
    carrierId: 406740,
    carrierName: "Ahead Of Time Transport Inc",
    cost: 425,
    miles: 38,
    margin: 271.34,
    rate: 696.34,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26550831,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-13T00:00:00",
    equipmentTypes: [1, 2],
    rank: 202,
    carrierId: 7138,
    carrierName: "Puma Logistics, Inc.",
    cost: 402.79,
    miles: 38,
    margin: 293.55,
    rate: 696.34,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26550830,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-13T00:00:00",
    equipmentTypes: [1, 2],
    rank: 202,
    carrierId: 396217,
    carrierName: "M A DRUMMER LLC",
    cost: 420,
    miles: 39,
    margin: 276.34,
    rate: 696.34,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26524521,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-04-13T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 222098,
    carrierName: "MGL Star Corp",
    cost: 700,
    miles: 18,
    margin: 139.78,
    rate: 839.78,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26539416,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 6176,
    destinationCityName: "Bensenville",
    destinationStateCode: "IL",
    destinationLatitude: 41.958,
    destinationLongitude: -87.918,
    loadDate: "2022-04-12T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 6726,
    carrierName: "W2 Logistic, Inc.",
    cost: 585.2,
    miles: 20,
    margin: 514.8,
    rate: 1100,
    customerId: 39830,
    customerName: "TR International Trading Company"
  },
  {
    loadId: 26538418,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-12T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 338428,
    carrierName: "M C D Fleet Services Inc",
    cost: 500,
    miles: 39,
    margin: 196.71,
    rate: 696.71,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26538417,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-12T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 343250,
    carrierName: "Sjt Trucking Inc",
    cost: 450,
    miles: 38,
    margin: 246.71,
    rate: 696.71,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26535216,
    originCityId: 6539,
    originCityName: "Glendale Heights",
    originStateCode: "IL",
    originLatitude: 41.857,
    originLongitude: -88.048,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-04-11T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 500,
    miles: 28,
    margin: 200,
    rate: 700,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26532085,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-11T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 461.93,
    miles: 38,
    margin: 234.78,
    rate: 696.71,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26532084,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-11T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 2794,
    carrierName: "Altex Transportation, Inc.",
    cost: 455.48,
    miles: 38,
    margin: 241.23,
    rate: 696.71,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26529457,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-11T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 175066,
    carrierName: "Shaddai Express, Inc.",
    cost: 462.57,
    miles: 38,
    margin: 234.14,
    rate: 696.71,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26529448,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-11T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 432152,
    carrierName: "HARVEY TRANSPORTATION LLC",
    cost: 425,
    miles: 39,
    margin: 271.71,
    rate: 696.71,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26521631,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-08T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 406846,
    carrierName: "Kingdom Express LLC",
    cost: 450,
    miles: 39,
    margin: 246.71,
    rate: 696.71,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26398715,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-04-07T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 203887,
    carrierName: "Get It Done Trucking LLC",
    cost: 700,
    miles: 45,
    margin: 91.11,
    rate: 791.11,
    customerId: 221622,
    customerName: "Lindt & Sprungli (North America) Inc. - BluJay"
  },
  {
    loadId: 26494216,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-04-05T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 450,
    miles: 8,
    margin: 150,
    rate: 600,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26469589,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 1557529,
    destinationCityName: "McCook",
    destinationStateCode: "IL",
    destinationLatitude: 41.798,
    destinationLongitude: -87.845,
    loadDate: "2022-04-05T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 170860,
    carrierName: "BEK Express, Inc.",
    cost: 650,
    miles: 14,
    margin: 57.98,
    rate: 707.98,
    customerId: 210537,
    customerName: "Richelieu Foods c/o Ryder - EDI"
  },
  {
    loadId: 26384748,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-04-05T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 170860,
    carrierName: "BEK Express, Inc.",
    cost: 750,
    miles: 45,
    margin: 44.83,
    rate: 794.83,
    customerId: 221622,
    customerName: "Lindt & Sprungli (North America) Inc. - BluJay"
  },
  {
    loadId: 26485307,
    originCityId: 6539,
    originCityName: "Glendale Heights",
    originStateCode: "IL",
    originLatitude: 41.857,
    originLongitude: -88.048,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-04-04T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 500,
    miles: 28,
    margin: 200,
    rate: 700,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26483185,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-04-04T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 455802,
    carrierName: "Zeid Express Inc",
    cost: 500,
    miles: 0,
    margin: -500,
    rate: 0,
    customerId: 5450,
    customerName: "Home Market Foods, Inc. - Outbound"
  },
  {
    loadId: 26479954,
    originCityId: 6436,
    originCityName: "Elk Grove Village",
    originStateCode: "IL",
    originLatitude: 41.988,
    originLongitude: -87.976,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-04-04T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 500,
    miles: 32,
    margin: 200,
    rate: 700,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26476229,
    originCityId: 6249,
    originCityName: "Calumet City",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.559,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-04-04T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 21466,
    carrierName: "Merx Global, Inc.",
    cost: 600,
    miles: 23,
    margin: 200,
    rate: 800,
    customerId: 14390,
    customerName: "Gardner-Gibson, Incorporated"
  },
  {
    loadId: 26460861,
    originCityId: 6592,
    originCityName: "Harvey",
    originStateCode: "IL",
    originLatitude: 41.601,
    originLongitude: -87.667,
    destinationCityId: 1557529,
    destinationCityName: "McCook",
    destinationStateCode: "IL",
    destinationLatitude: 41.798,
    destinationLongitude: -87.845,
    loadDate: "2022-04-04T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 194478,
    carrierName: "Bk Delivery Express Inc",
    cost: 550,
    miles: 23,
    margin: 100,
    rate: 650,
    customerId: 60870,
    customerName: "Vieira's Bakery Inc"
  },
  {
    loadId: 26384751,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-04-04T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 223521,
    carrierName: "HTH Express LLC",
    cost: 750,
    miles: 42,
    margin: 44.83,
    rate: 794.83,
    customerId: 221622,
    customerName: "Lindt & Sprungli (North America) Inc. - BluJay"
  },
  {
    loadId: 26491932,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-04-01T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 199721,
    carrierName: "MTZ Trucking Services, Inc.",
    cost: 450,
    miles: 8,
    margin: 400,
    rate: 850,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26470511,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-01T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 189887,
    carrierName: "Landliner, Inc.",
    cost: 412,
    miles: 39,
    margin: 83,
    rate: 495,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26470509,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-04-01T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 366741,
    carrierName: "AGM Trans Force, Inc.",
    cost: 450,
    miles: 38,
    margin: 247.08,
    rate: 697.08,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26438512,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-04-01T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 451119,
    carrierName: "E&C TRUCKING AND TRANSPORTATION LLC",
    cost: 400,
    miles: 30,
    margin: 105.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 26431832,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 1557398,
    destinationCityName: "Hodgkins",
    destinationStateCode: "IL",
    destinationLatitude: 41.818,
    destinationLongitude: -87.87,
    loadDate: "2022-04-01T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 210755,
    carrierName: "Elite Midwestern Transportation, Inc.",
    cost: 650,
    miles: 17,
    margin: 250,
    rate: 900,
    customerId: 15850,
    customerName: "L.A. Foods, LLC"
  },
  {
    loadId: 26384744,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-04-01T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 74416,
    carrierName: "AGM Transport Inc",
    cost: 675.58,
    miles: 45,
    margin: 119.25,
    rate: 794.83,
    customerId: 221622,
    customerName: "Lindt & Sprungli (North America) Inc. - BluJay"
  },
  {
    loadId: 26461942,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-03-31T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 80303,
    carrierName: "Real Trucking, Inc.",
    cost: 500,
    miles: 30,
    margin: 5.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 26454432,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-03-31T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 51651,
    carrierName: "IMG Trucking, Inc.",
    cost: 600,
    miles: 8,
    margin: 50,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 26432888,
    originCityId: 6269,
    originCityName: "Carol Stream",
    originStateCode: "IL",
    originLatitude: 41.904,
    originLongitude: -88.121,
    destinationCityId: 6199,
    destinationCityName: "Bolingbrook",
    destinationStateCode: "IL",
    destinationLatitude: 41.711,
    destinationLongitude: -88.069,
    loadDate: "2022-03-31T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 170860,
    carrierName: "BEK Express, Inc.",
    cost: 700,
    miles: 19,
    margin: 140.37,
    rate: 840.37,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26452725,
    originCityId: 6436,
    originCityName: "Elk Grove Village",
    originStateCode: "IL",
    originLatitude: 41.988,
    originLongitude: -87.976,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-03-30T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 500,
    miles: 32,
    margin: 200,
    rate: 700,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26445240,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-03-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 500,
    miles: 8,
    margin: 150,
    rate: 650,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26441324,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-29T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 21466,
    carrierName: "Merx Global, Inc.",
    cost: 600,
    miles: 24,
    margin: 425,
    rate: 1025,
    customerId: 171330,
    customerName: "DuPont c/o APL Special Services"
  },
  {
    loadId: 26439012,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-28T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 215604,
    carrierName: "MIDWEST TRANSPORTATION GROUP INC",
    cost: 500,
    miles: 39,
    margin: 196.71,
    rate: 696.71,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26419866,
    originCityId: 7636,
    originCityName: "Hammond",
    originStateCode: "IN",
    originLatitude: 41.589,
    originLongitude: -87.479,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-03-28T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 448510,
    carrierName: "ASH AND D TRANSPORTATION INC",
    cost: 500,
    miles: 30,
    margin: 5.4,
    rate: 505.4,
    customerId: 77560,
    customerName: "CITGO Petroleum Corp"
  },
  {
    loadId: 26422230,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 7350,
    destinationCityName: "Wood Dale",
    destinationStateCode: "IL",
    destinationLatitude: 41.962,
    destinationLongitude: -87.96,
    loadDate: "2022-03-25T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 450,
    miles: 2,
    margin: 400,
    rate: 850,
    customerId: 215445,
    customerName: "3M International"
  },
  {
    loadId: 26420964,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-25T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 287560,
    carrierName: "Recycling Materials, Inc.",
    cost: 450,
    miles: 38,
    margin: 246.71,
    rate: 696.71,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26420961,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-25T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 287560,
    carrierName: "Recycling Materials, Inc.",
    cost: 450,
    miles: 38,
    margin: 246.71,
    rate: 696.71,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26402534,
    originCityId: 7355,
    originCityName: "Woodridge",
    originStateCode: "IL",
    originLatitude: 41.738,
    originLongitude: -88.028,
    destinationCityId: 6269,
    destinationCityName: "Carol Stream",
    destinationStateCode: "IL",
    destinationLatitude: 41.904,
    destinationLongitude: -88.121,
    loadDate: "2022-03-25T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 170860,
    carrierName: "BEK Express, Inc.",
    cost: 800,
    miles: 18,
    margin: 54.29,
    rate: 854.29,
    customerId: 383,
    customerName: "The Kraft Heinz Company"
  },
  {
    loadId: 26415156,
    originCityId: 7235,
    originCityName: "Tinley Park",
    originStateCode: "IL",
    originLatitude: 41.563,
    originLongitude: -87.792,
    destinationCityId: 6975,
    destinationCityName: "Orland Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.626,
    destinationLongitude: -87.84,
    loadDate: "2022-03-24T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 450,
    miles: 8,
    margin: 200,
    rate: 650,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26410348,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-24T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 30572,
    carrierName: "A&M Quality Transport, Inc.",
    cost: 450,
    miles: 39,
    margin: 246.71,
    rate: 696.71,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26410343,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-24T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 30572,
    carrierName: "A&M Quality Transport, Inc.",
    cost: 450,
    miles: 39,
    margin: 246.71,
    rate: 696.71,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26404302,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-03-23T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 450,
    miles: 8,
    margin: 150,
    rate: 600,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26399440,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-23T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 215604,
    carrierName: "MIDWEST TRANSPORTATION GROUP INC",
    cost: 500,
    miles: 39,
    margin: 198.01,
    rate: 698.01,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26285242,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-03-23T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 369480,
    carrierName: "AAE Trucking Services Inc",
    cost: 350,
    miles: 0,
    margin: 125,
    rate: 475,
    customerId: 223680,
    customerName: "Rdi Scrap Recycling Inc"
  },
  {
    loadId: 26369473,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 1557417,
    destinationCityName: "Summit",
    destinationStateCode: "IL",
    destinationLatitude: 41.781,
    destinationLongitude: -87.826,
    loadDate: "2022-03-21T00:00:00",
    equipmentTypes: [2],
    rank: 203,
    carrierId: 181499,
    carrierName: "I V Brothers Corp",
    cost: 650,
    miles: 13,
    margin: 225,
    rate: 875,
    customerId: 55882,
    customerName: "Export Packers Company Limited"
  },
  {
    loadId: 26362706,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6829,
    destinationCityName: "Melrose Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.91,
    destinationLongitude: -87.837,
    loadDate: "2022-03-21T00:00:00",
    equipmentTypes: [3],
    rank: 203,
    carrierId: 397069,
    carrierName: "DREAMVILLE TRUCKING COMPANY",
    cost: 500,
    miles: 12,
    margin: 50,
    rate: 550,
    customerId: 11538,
    customerName: "Duferco Steel Inc."
  },
  {
    loadId: 26364644,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-18T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 231753,
    carrierName: "Three Plus One Corp",
    cost: 475,
    miles: 39,
    margin: 172.28,
    rate: 647.28,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26364643,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-18T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 171279,
    carrierName: "Alynevych, Inc.",
    cost: 525,
    miles: 39,
    margin: 122.28,
    rate: 647.28,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26326432,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-03-18T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 199721,
    carrierName: "MTZ Trucking Services, Inc.",
    cost: 450,
    miles: 8,
    margin: 150,
    rate: 600,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26355475,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 7350,
    destinationCityName: "Wood Dale",
    destinationStateCode: "IL",
    destinationLatitude: 41.962,
    destinationLongitude: -87.96,
    loadDate: "2022-03-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 211063,
    carrierName: "Royal Exchange Inc",
    cost: 400,
    miles: 2,
    margin: 450,
    rate: 850,
    customerId: 215445,
    customerName: "3M International"
  },
  {
    loadId: 26354650,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-17T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 296587,
    carrierName: "Magi Truck, Inc.",
    cost: 450,
    miles: 39,
    margin: 66.38,
    rate: 516.38,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26326430,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-03-17T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 199721,
    carrierName: "MTZ Trucking Services, Inc.",
    cost: 450,
    miles: 8,
    margin: 150,
    rate: 600,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26319410,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6308,
    destinationCityName: "Cicero",
    destinationStateCode: "IL",
    destinationLatitude: 41.844,
    destinationLongitude: -87.762,
    loadDate: "2022-03-17T00:00:00",
    equipmentTypes: [1],
    rank: 201,
    carrierId: 363466,
    carrierName: "Everest Transit, Inc.",
    cost: 450,
    miles: 8,
    margin: 200,
    rate: 650,
    customerId: 50028,
    customerName: "Breakthru Beverage Illinois, LLC"
  },
  {
    loadId: 26348500,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-16T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 411977,
    carrierName: "NORTHSIDE TRANSPORTATION GROUP INC",
    cost: 500,
    miles: 39,
    margin: 122.28,
    rate: 622.28,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26326429,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-03-16T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 199721,
    carrierName: "MTZ Trucking Services, Inc.",
    cost: 450,
    miles: 8,
    margin: 150,
    rate: 600,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26269414,
    originCityId: 6087,
    originCityName: "Addison",
    originStateCode: "IL",
    originLatitude: 41.939,
    originLongitude: -88.033,
    destinationCityId: 1557529,
    destinationCityName: "McCook",
    destinationStateCode: "IL",
    destinationLatitude: 41.798,
    destinationLongitude: -87.845,
    loadDate: "2022-03-16T00:00:00",
    equipmentTypes: [2],
    rank: 202,
    carrierId: 328785,
    carrierName: "PPT LLC",
    cost: 700,
    miles: 19.4,
    margin: 394.68,
    rate: 1094.68,
    customerId: 65914,
    customerName: "LXP Armada"
  },
  {
    loadId: 26342139,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-03-15T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 357842,
    carrierName: "Felix Transportation LLC",
    cost: 481,
    miles: 31,
    margin: 19,
    rate: 500,
    customerId: 223503,
    customerName: "USPS - Covid Test Kits IL"
  },
  {
    loadId: 26340189,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-03-15T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 270337,
    carrierName: "EUGENE TRANSPORT INC",
    cost: 495.26,
    miles: 31,
    margin: 4.74,
    rate: 500,
    customerId: 223503,
    customerName: "USPS - Covid Test Kits IL"
  },
  {
    loadId: 26340188,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-03-15T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 378362,
    carrierName: "American 1 Logistics Inc",
    cost: 500,
    miles: 31,
    margin: 0,
    rate: 500,
    customerId: 223503,
    customerName: "USPS - Covid Test Kits IL"
  },
  {
    loadId: 26340186,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-03-15T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 204065,
    carrierName: "KNM Express INC",
    cost: 550,
    miles: 31,
    margin: -50,
    rate: 500,
    customerId: 223503,
    customerName: "USPS - Covid Test Kits IL"
  },
  {
    loadId: 26340114,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-03-15T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 440934,
    carrierName: "Tamvasco Transportation LLC",
    cost: 495.26,
    miles: 31,
    margin: 4.74,
    rate: 500,
    customerId: 223503,
    customerName: "USPS - Covid Test Kits IL"
  },
  {
    loadId: 26335807,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-03-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 243094,
    carrierName: "Roland Logistics, Inc.",
    cost: 500,
    miles: 17,
    margin: 200,
    rate: 700,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26331738,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-03-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 199721,
    carrierName: "MTZ Trucking Services, Inc.",
    cost: 400,
    miles: 20,
    margin: 450,
    rate: 850,
    customerId: 215445,
    customerName: "3M International"
  },
  {
    loadId: 26331737,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-03-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 199721,
    carrierName: "MTZ Trucking Services, Inc.",
    cost: 400,
    miles: 20,
    margin: 450,
    rate: 850,
    customerId: 215445,
    customerName: "3M International"
  },
  {
    loadId: 26331736,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-03-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 207741,
    carrierName: "Load Runners, Inc.",
    cost: 461.03,
    miles: 20,
    margin: 388.97,
    rate: 850,
    customerId: 215445,
    customerName: "3M International"
  },
  {
    loadId: 26326428,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-03-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 199721,
    carrierName: "MTZ Trucking Services, Inc.",
    cost: 450,
    miles: 8,
    margin: 150,
    rate: 600,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26319446,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-03-15T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 199721,
    carrierName: "MTZ Trucking Services, Inc.",
    cost: 450,
    miles: 24,
    margin: 175,
    rate: 625,
    customerId: 196487,
    customerName: "Brainiac Kids / Ingenuity Foods, Inc."
  },
  {
    loadId: 26327354,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-03-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 401855,
    carrierName: "Dogstone Logistics, LLC",
    cost: 500,
    miles: 0,
    margin: 400,
    rate: 900,
    customerId: 223958,
    customerName: "Encompass Media Group Inc."
  },
  {
    loadId: 26326426,
    originCityId: 6975,
    originCityName: "Orland Park",
    originStateCode: "IL",
    originLatitude: 41.626,
    originLongitude: -87.84,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-03-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 199721,
    carrierName: "MTZ Trucking Services, Inc.",
    cost: 450,
    miles: 8,
    margin: 150,
    rate: 600,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26319557,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-14T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 211063,
    carrierName: "Royal Exchange Inc",
    cost: 500,
    miles: 39,
    margin: 119.69,
    rate: 619.69,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26319334,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-14T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 396217,
    carrierName: "M A DRUMMER LLC",
    cost: 500,
    miles: 39,
    margin: -9.75,
    rate: 490.25,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26318737,
    originCityId: 6654,
    originCityName: "Itasca",
    originStateCode: "IL",
    originLatitude: 41.971,
    originLongitude: -88.018,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-03-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 296587,
    carrierName: "Magi Truck, Inc.",
    cost: 600,
    miles: 45,
    margin: 487,
    rate: 1087,
    customerId: 67674,
    customerName: "The Valspar Corporation/Sherwin Williams"
  },
  {
    loadId: 26316003,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 6875,
    destinationCityName: "Morton Grove",
    destinationStateCode: "IL",
    destinationLatitude: 42.036,
    destinationLongitude: -87.8,
    loadDate: "2022-03-14T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 211063,
    carrierName: "Royal Exchange Inc",
    cost: 550,
    miles: 37,
    margin: 350,
    rate: 900,
    customerId: 161435,
    customerName: "Zenlen Inc / Native"
  },
  {
    loadId: 26313764,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 7350,
    destinationCityName: "Wood Dale",
    destinationStateCode: "IL",
    destinationLatitude: 41.962,
    destinationLongitude: -87.96,
    loadDate: "2022-03-11T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 383369,
    carrierName: "Tracey Total Transportation Inc",
    cost: 400,
    miles: 2,
    margin: 450,
    rate: 850,
    customerId: 215445,
    customerName: "3M International"
  },
  {
    loadId: 26309839,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-11T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 550,
    miles: 39,
    margin: -36.35,
    rate: 513.65,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26309836,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-11T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 427283,
    carrierName: "ACE OF STATE CO",
    cost: 431.16,
    miles: 39,
    margin: 82.49,
    rate: 513.65,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26306518,
    originCityId: 6654,
    originCityName: "Itasca",
    originStateCode: "IL",
    originLatitude: 41.971,
    originLongitude: -88.018,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-03-11T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 171279,
    carrierName: "Alynevych, Inc.",
    cost: 800,
    miles: 45,
    margin: 327,
    rate: 1127,
    customerId: 67674,
    customerName: "The Valspar Corporation/Sherwin Williams"
  },
  {
    loadId: 26301390,
    originCityId: 6164,
    originCityName: "Bedford Park",
    originStateCode: "IL",
    originLatitude: 41.769,
    originLongitude: -87.832,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-11T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 21466,
    carrierName: "Merx Global, Inc.",
    cost: 700,
    miles: 24,
    margin: 500,
    rate: 1200,
    customerId: 171330,
    customerName: "DuPont c/o APL Special Services"
  },
  {
    loadId: 26174603,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-03-11T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 203887,
    carrierName: "Get It Done Trucking LLC",
    cost: 800,
    miles: 42,
    margin: -184.4,
    rate: 615.6,
    customerId: 52926,
    customerName: "Lindt & Sprungli (North America) Inc."
  },
  {
    loadId: 26308906,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-03-10T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 273804,
    carrierName: "Firebird Trucking, Inc.",
    cost: 400,
    miles: 5,
    margin: 450,
    rate: 850,
    customerId: 215445,
    customerName: "3M International"
  },
  {
    loadId: 26304831,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-03-10T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 202932,
    carrierName: "Pride USA, Inc.",
    cost: 450,
    miles: 5,
    margin: 400,
    rate: 850,
    customerId: 215445,
    customerName: "3M International"
  },
  {
    loadId: 26304830,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6436,
    destinationCityName: "Elk Grove Village",
    destinationStateCode: "IL",
    destinationLatitude: 41.988,
    destinationLongitude: -87.976,
    loadDate: "2022-03-10T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 230840,
    carrierName: "Millennial Transport, Inc.",
    cost: 373.86,
    miles: 5,
    margin: 476.14,
    rate: 850,
    customerId: 215445,
    customerName: "3M International"
  },
  {
    loadId: 26302277,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-10T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 219004,
    carrierName: "Byland Transportation LLC",
    cost: 500,
    miles: 38,
    margin: 13.65,
    rate: 513.65,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26300550,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-10T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 211063,
    carrierName: "Royal Exchange Inc",
    cost: 500,
    miles: 39,
    margin: -9.75,
    rate: 490.25,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26289385,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-10T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 208765,
    carrierName: "Rod and EJ Trucking, LLC",
    cost: 550,
    miles: 39,
    margin: -59.75,
    rate: 490.25,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26174605,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-03-10T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 203887,
    carrierName: "Get It Done Trucking LLC",
    cost: 800,
    miles: 40,
    margin: -184.4,
    rate: 615.6,
    customerId: 52926,
    customerName: "Lindt & Sprungli (North America) Inc."
  },
  {
    loadId: 26293451,
    originCityId: 7096,
    originCityName: "Roselle",
    originStateCode: "IL",
    originLatitude: 41.977,
    originLongitude: -88.076,
    destinationCityId: 7235,
    destinationCityName: "Tinley Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.563,
    destinationLongitude: -87.792,
    loadDate: "2022-03-09T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 500,
    miles: 39,
    margin: 200,
    rate: 700,
    customerId: 218950,
    customerName: "Panduit Corp c/o Tranzact - Manual"
  },
  {
    loadId: 26289386,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-09T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 329514,
    carrierName: "CRR Transport LLC",
    cost: 495,
    miles: 39,
    margin: -4.75,
    rate: 490.25,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26203653,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-03-09T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 244610,
    carrierName: "Esco Transportation, Inc.",
    cost: 400,
    miles: 0,
    margin: 325,
    rate: 725,
    customerId: 66539,
    customerName: "Kaul Glove and Mfg. Co."
  },
  {
    loadId: 26174608,
    originCityId: 6199,
    originCityName: "Bolingbrook",
    originStateCode: "IL",
    originLatitude: 41.711,
    originLongitude: -88.069,
    destinationCityId: 7636,
    destinationCityName: "Hammond",
    destinationStateCode: "IN",
    destinationLatitude: 41.589,
    destinationLongitude: -87.479,
    loadDate: "2022-03-09T00:00:00",
    equipmentTypes: [2],
    rank: 201,
    carrierId: 203887,
    carrierName: "Get It Done Trucking LLC",
    cost: 800,
    miles: 40,
    margin: -184.4,
    rate: 615.6,
    customerId: 52926,
    customerName: "Lindt & Sprungli (North America) Inc."
  },
  {
    loadId: 26286428,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-03-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 233875,
    carrierName: "Ang Transportation, Inc.",
    cost: 500,
    miles: 20,
    margin: 350,
    rate: 850,
    customerId: 215445,
    customerName: "3M International"
  },
  {
    loadId: 26284613,
    originCityId: 6390,
    originCityName: "Dolton",
    originStateCode: "IL",
    originLatitude: 41.624,
    originLongitude: -87.599,
    destinationCityId: 6087,
    destinationCityName: "Addison",
    destinationStateCode: "IL",
    destinationLatitude: 41.939,
    destinationLongitude: -88.033,
    loadDate: "2022-03-08T00:00:00",
    equipmentTypes: [1],
    rank: 202,
    carrierId: 6529,
    carrierName: "AmeriFreight, Inc.",
    cost: 400,
    miles: 38,
    margin: 113.65,
    rate: 513.65,
    customerId: 22354,
    customerName: "Caravan Ingredients c/o Lean Logistics"
  },
  {
    loadId: 26282502,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 6302,
    destinationCityName: "Chicago",
    destinationStateCode: "IL",
    destinationLatitude: 41.874,
    destinationLongitude: -87.651,
    loadDate: "2022-03-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 80303,
    carrierName: "Real Trucking, Inc.",
    cost: 425,
    miles: 20,
    margin: 425,
    rate: 850,
    customerId: 215445,
    customerName: "3M International"
  },
  {
    loadId: 26282501,
    originCityId: 6176,
    originCityName: "Bensenville",
    originStateCode: "IL",
    originLatitude: 41.958,
    originLongitude: -87.918,
    destinationCityId: 7350,
    destinationCityName: "Wood Dale",
    destinationStateCode: "IL",
    destinationLatitude: 41.962,
    destinationLongitude: -87.96,
    loadDate: "2022-03-08T00:00:00",
    equipmentTypes: [1],
    rank: 203,
    carrierId: 230840,
    carrierName: "Millennial Transport, Inc.",
    cost: 419.6,
    miles: 2,
    margin: 430.4,
    rate: 850,
    customerId: 215445,
    customerName: "3M International"
  },
  {
    loadId: 26233191,
    originCityId: 6302,
    originCityName: "Chicago",
    originStateCode: "IL",
    originLatitude: 41.874,
    originLongitude: -87.651,
    destinationCityId: 6164,
    destinationCityName: "Bedford Park",
    destinationStateCode: "IL",
    destinationLatitude: 41.769,
    destinationLongitude: -87.832,
    loadDate: "2022-03-08T00:00:00",
    equipmentTypes: [1, 2],
    rank: 201,
    carrierId: 343250,
    carrierName: "Sjt Trucking Inc",
    cost: 500,
    miles: 14,
    margin: 15.12,
    rate: 515.12,
    customerId: 82032,
    customerName: "Ingredion Incorporated / Corn Products Intl."
  }
];

export const analyticsInboundOutboundMockData = { inbound: 52, outbound: 117 };